import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { clubService, athleteService, adminService, videoService, imageService, eventService, Club, Athlete, Admin } from '../services/api';
import Charts from './Charts';

// Icônes SVG professionnelles
const DashboardIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M13 3v6h8V3m-8 18h8V11h-8M3 21h8v-6H3m0-2h8V3H3v10Z"/>
  </svg>
);

const ClubIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"/>
  </svg>
);

const AthleteIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2m4 18v-6h2.5l-2.54-7.63a1.5 1.5 0 0 0-1.43-1.01c-.4 0-.77.17-1.03.46L16.5 10H15l-1.5-2.5c-.26-.29-.63-.46-1.03-.46-.83 0-1.5.67-1.5 1.5 0 .35.13.67.35.91L13 11.5v3.5l-2.58 3.85c-.26.39-.16.91.23 1.17.39.26.91.16 1.17-.23L14 16v-3.5l2.5-2.5c.26-.26.67-.35 1.03-.35.83 0 1.5.67 1.5 1.5 0 .35-.13.67-.35.91L16.5 13.5V22h3.5z"/>
  </svg>
);

const PendingIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12,20A7,7 0 0,1 5,13A7,7 0 0,1 12,6A7,7 0 0,1 19,13A7,7 0 0,1 12,20M19.03,7.39L20.45,5.97C20,5.46 19.55,5 19.04,4.56L17.62,6C16.07,4.74 14.12,4 12,4A9,9 0 0,0 3,13A9,9 0 0,0 12,22C17,22 21,17.97 21,13C21,10.88 20.26,8.93 19.03,7.39M11,14H13V8H11M15,1H9V3H15V1Z"/>
  </svg>
);

const SettingsIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M10,22C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.79,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,13L21.54,14.63C21.73,14.78 21.79,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.04 19.05,18.95L16.56,17.95C16.04,18.34 15.5,18.68 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10M11.25,4L10.88,6.61C9.68,6.86 8.62,7.5 7.85,8.39L5.44,7.35L4.69,8.65L6.8,10.2C6.4,11.37 6.4,12.64 6.8,13.8L4.68,15.36L5.43,16.66L7.86,15.62C8.63,16.5 9.68,17.14 10.87,17.38L11.24,20H12.76L13.13,17.39C14.32,17.14 15.37,16.5 16.14,15.62L18.57,16.66L19.32,15.36L17.2,13.81C17.6,12.64 17.6,11.37 17.2,10.2L19.31,8.65L18.56,7.35L16.15,8.39C15.38,7.5 14.32,6.86 13.12,6.62L12.75,4H11.25Z"/>
  </svg>
);

const LogoutIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z"/>
  </svg>
);

const LockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12,17A2,2 0 0,0 14,15C14,13.89 13.1,13 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V10C4,8.89 4.9,8 6,8H7V6A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,3A3,3 0 0,0 9,6V8H15V6A3,3 0 0,0 12,3Z"/>
  </svg>
);

const ApproveIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"/>
  </svg>
);

const RejectIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M12 20C7.59 20 4 16.41 4 12S7.59 4 12 4 20 7.59 20 12 16.41 20 12 20M12 10.59L16.59 6L18 7.41L13.41 12L18 16.59L16.59 18L12 13.41L7.41 18L6 16.59L10.59 12L6 7.41L7.41 6L12 10.59Z"/>
  </svg>
);

const WarningIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"/>
  </svg>
);

const CheckCircleIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.5 2 2 6.5 2 12S6.5 22 12 22 22 17.5 22 12 17.5 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"/>
  </svg>
);

const ToolIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M22.7 19L13.6 9.9C14.5 7.6 14 4.9 12.1 3C10.1 1 7.1 1 5.1 3S1 8.9 3 10.9C4.9 12.8 7.6 13.3 9.9 12.4L19 21.7C19.4 22.1 20 22.1 20.4 21.7L22.7 19.4C23.1 19 23.1 18.4 22.7 19M5.6 9.4C4.6 8.4 4.6 6.8 5.6 5.8S8.2 4.6 9.2 5.6 10.4 8.2 9.4 9.2 6.6 10.4 5.6 9.4Z"/>
  </svg>
);

const VideoIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17 10.5V7A1 1 0 0 0 16 6H4A1 1 0 0 0 3 7V17A1 1 0 0 0 4 18H16A1 1 0 0 0 17 17V13.5L21 17.5V6.5L17 10.5Z"/>
  </svg>
);

const PhotoIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M8.5 13.5L11 16.5L14.5 12L19 18H5M21 19V5C21 3.89 20.1 3 19 3H5A2 2 0 0 0 3 5V19A2 2 0 0 0 5 21H19A2 2 0 0 0 21 19Z"/>
  </svg>
);

const AddIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"/>
  </svg>
);

const AdminUserIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
  </svg>
);

const UploadIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M14 2H6A2 2 0 0 0 4 4V20A2 2 0 0 0 6 22H18A2 2 0 0 0 20 20V8L14 2M18 20H6V4H13V9H18V20Z"/>
  </svg>
);

const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M15.5 14h-.79l-.28-.27a6.51 6.51 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
  </svg>
);

const PrintIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"/>
  </svg>
);

const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
  </svg>
);

const DeleteIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
  </svg>
);

const ClearIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
  </svg>
);

const MenuToggleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
  </svg>
);

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
  </svg>
);

const FinanceIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
  </svg>
);

// Composant de filtre par année réutilisable
const YearFilter = ({ 
  selectedYear, 
  onYearChange, 
  availableYears, 
  label = "Filtrer par année :" 
}: {
  selectedYear: number;
  onYearChange: (year: number) => void;
  availableYears: number[];
  label?: string;
}) => {
  // Générer les années : année en cours + 5 années précédentes
  const currentYear = new Date().getFullYear();
  const defaultYears = [];
  for (let i = 0; i <= 5; i++) {
    defaultYears.push(currentYear - i);
  }
  
  // Combiner les années par défaut avec les années disponibles et supprimer les doublons
  const allYears = Array.from(new Set([...defaultYears, ...availableYears])).sort((a, b) => b - a);
  
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      {label && (
        <label style={{ 
          fontSize: '0.9rem', 
          color: '#374151', 
          fontWeight: '600',
          whiteSpace: 'nowrap'
        }}>
          {label}
        </label>
      )}
      <div style={{ position: 'relative' }}>
        <select
          value={selectedYear}
          onChange={(e) => onYearChange(Number(e.target.value))}
          style={{
            padding: '10px 16px',
            border: '2px solid #e5e7eb',
            borderRadius: '12px',
            fontSize: '0.9rem',
            color: '#1f2937',
            cursor: 'pointer',
            fontWeight: '500',
            minWidth: '120px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
            transition: 'all 0.2s ease',
            appearance: 'none',
            backgroundImage: `linear-gradient(135deg, #ffffff 0%, #f9fafb 100%), url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
            backgroundRepeat: 'no-repeat, no-repeat',
            backgroundPosition: '0 0, right 12px center',
            backgroundSize: 'auto, 16px',
            paddingRight: '40px'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = '#10b981';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.15)';
            e.currentTarget.style.transform = 'translateY(-1px)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = '#e5e7eb';
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.05)';
            e.currentTarget.style.transform = 'translateY(0)';
          }}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = '#10b981';
            e.currentTarget.style.boxShadow = '0 0 0 3px rgba(16, 185, 129, 0.1)';
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = '#e5e7eb';
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.05)';
          }}
        >
          {allYears.map(year => (
            <option 
              key={year} 
              value={year}
              style={{
                padding: '8px',
                fontSize: '0.9rem',
                fontWeight: year === currentYear ? '600' : '400',
                color: year === currentYear ? '#10b981' : '#1f2937'
              }}
            >
              {year === currentYear ? `${year} (Année en cours)` : year.toString()}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  @media (max-width: 768px) {
    display: block;
  }
`;

const MobileOverlay = styled.div<{ isOpen: boolean }>`
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: ${props => props.isOpen ? 1 : 0};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, visibility 0.3s ease;

  @media (max-width: 768px) {
    display: block;
  }
`;

// Types
interface LoginForm {
  email: string;
  password: string;
}

interface ApprovalModal {
  isOpen: boolean;
  type: 'club' | 'athlete' | null;
  itemId: string | null;
  itemName: string | null;
  montantAdhesion: string;
}

type AdminTab = 'dashboard' | 'clubs' | 'athletes' | 'pending-clubs' | 'pending-athletes' | 'finance' | 'gestions' | 'settings' | 'admins';

interface MediaItem {
  id: string;
  title: string;
  description: string;
  url: string;
  thumbnail?: string;
  duration?: string;
  category: string;
  datePublication: Date;
  heurePublication: string;
  type: 'video' | 'photo';
}

type GestionView = 'main' | 'videos' | 'photos' | 'galerie' | 'calendrier';

interface MediaForm {
  title: string;
  description: string;
  url: string;
  thumbnail?: string;
  duration?: string;
  category: string;
}

// Composants stylisés
const AdminContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f5f5f5;
  position: relative;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const AdminNavbar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 80px;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.3);
  z-index: 1001;

  @media (max-width: 768px) {
    padding: 0 15px;
  }
`;

const NavbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const NavbarLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.5rem;
  font-weight: 700;
`;

const NavbarTitle = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const NavbarUser = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const UserInfo = styled.div`
  text-align: right;
`;

const UserName = styled.div`
  font-weight: 600;
  font-size: 1rem;
`;

const UserRole = styled.div`
  font-size: 0.8rem;
  opacity: 0.8;
`;

const NavbarActions = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavbarButton = styled.button`
  padding: 8px 16px;
  background: rgba(255,255,255,0.1);
  border: 1px solid rgba(255,255,255,0.2);
  color: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover {
    background: rgba(255,255,255,0.2);
  }
`;

const Sidebar = styled.div<{ isOpen: boolean }>`
  width: 280px;
  background: linear-gradient(180deg, #2d2d2d 0%, #1a1a1a 100%);
  color: white;
  padding: 20px 0;
  box-shadow: 2px 0 10px rgba(0,0,0,0.3);
  position: fixed;
  top: 80px;
  left: 0;
  height: calc(100vh - 80px);
  overflow-y: auto;
  z-index: 1000;
  transition: transform 0.3s ease;

  @media (max-width: 768px) {
    width: 100%;
    transform: ${props => props.isOpen ? 'translateX(0)' : 'translateX(-100%)'};
  }
`;

const SidebarHeader = styled.div`
  padding: 0 20px 20px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  margin-bottom: 20px;
`;

const AdminName = styled.h2`
  font-size: 1.2rem;
  margin: 0 0 5px 0;
  font-weight: 600;
`;

const AdminEmail = styled.p`
  font-size: 0.9rem;
  opacity: 0.8;
  margin: 0;
`;

const SidebarMenu = styled.nav`
  padding: 0 20px;
`;

const MenuItem = styled.button<{ active: boolean }>`
  width: 100%;
  padding: 15px 20px;
  margin-bottom: 8px;
  border: none;
  background: ${props => props.active ? 'rgba(255,255,255,0.2)' : 'transparent'};
  color: white;
  text-align: left;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  font-size: 1.05rem;
  font-weight: 500;
  
  &:hover {
    background: rgba(255,255,255,0.1);
  }
`;

const MenuIcon = styled.span`
  margin-right: 15px;
  font-size: 1.3rem;
  display: flex;
  align-items: center;
`;

const LogoutButton = styled.button`
  width: calc(100% - 40px);
  margin: 20px;
  padding: 15px;
  border: 1px solid rgba(255,255,255,0.3);
  background: transparent;
  color: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.05rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  
  &:hover {
    background: rgba(255,255,255,0.1);
  }
`;

const MainContent = styled.div`
  flex: 1;
  padding: 30px;
  overflow-y: auto;
  margin-left: 280px;
  margin-top: 80px;
  min-height: calc(100vh - 80px);

  @media (max-width: 768px) {
    margin-left: 0;
    padding: 20px;
  }
`;

const PageHeader = styled.div`
  margin-bottom: 30px;
`;

const PageTitle = styled.h1`
  font-size: 2rem;
  color: #333;
  margin: 0 0 10px 0;
  font-weight: 700;
`;

const PageSubtitle = styled.p`
  color: #666;
  margin: 0;
  font-size: 1.1rem;
`;

// Composants pour l'authentification
const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #0a192f 0%, #172a45 50%, #263b5c 100%);
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('/karate5.gif') center/cover no-repeat;
    opacity: 0.1;
    z-index: 0;
  }
`;

const LoginCard = styled.div`
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  padding: 50px 45px;
  border-radius: 30px;
  box-shadow: 0 30px 100px rgba(0,0,0,0.4), 0 0 0 1px rgba(255,255,255,0.1);
  width: 100%;
  max-width: 450px;
  position: relative;
  z-index: 1;
  border: 1px solid rgba(255, 255, 255, 0.2);
  
  @media (max-width: 768px) {
    padding: 40px 30px;
    border-radius: 25px;
    margin: 20px;
  }
`;

const LoginTitle = styled.h1`
  text-align: center;
  color: #000000;
  margin-bottom: 40px;
  font-size: 2.2rem;
  font-family: 'Poppins', 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  font-weight: 900;
  letter-spacing: -0.02em;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  
  svg {
    width: 32px;
    height: 32px;
  }
`;

const FormGroup = styled.div`
  margin-bottom: 25px;
  position: relative;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 10px;
  color: #1e293b;
  font-weight: 700;
  font-family: 'Poppins', 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  font-size: 0.95rem;
  letter-spacing: 0.3px;
`;

const Input = styled.input`
  width: 100%;
  padding: 16px 18px;
  border: 2px solid #000000 !important;
  border-radius: 12px;
  font-size: 1rem;
  font-family: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: white;
  color: #1e293b;
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
  
  &::placeholder {
    color: #94a3b8;
    font-weight: 400;
  }
  
  &:hover {
    border-color: #000000 !important;
    box-shadow: 0 4px 8px rgba(0,0,0,0.05);
  }
  
  &:focus {
    outline: none;
    border-color: #000000 !important;
    box-shadow: 0 0 0 4px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
  }
  
  &:invalid {
    border-color: #000000 !important;
  }
  
  &:valid {
    border-color: #000000 !important;
  }
`;

const PasswordToggleButton = styled.button`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: rgba(0, 0, 0, 0.04);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #111827;
  font-size: 1rem;
  transition: all 0.2s ease;
  padding: 0;
  line-height: 1;

  &:hover {
    background: rgba(0, 0, 0, 0.08);
    transform: translateY(-50%) scale(1.03);
  }

  &:active {
    transform: translateY(-50%) scale(0.98);
  }
`;

const LoginButton = styled.button`
  width: 100%;
  padding: 18px 35px;
  background: linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%);
  color: white;
  border: none;
  border-radius: 15px;
  font-size: 1.1rem;
  font-weight: 700;
  font-family: 'Poppins', 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: uppercase;
  letter-spacing: 1.5px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(16, 185, 129, 0.3);
  margin-top: 10px;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s ease;
  }
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 30px rgba(16, 185, 129, 0.4);
    background: linear-gradient(135deg, #059669 0%, #047857 50%, #065f46 100%);
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(-1px);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

// Composants pour le tableau de bord
const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

const StatCard = styled.div`
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  text-align: center;
  border-left: 4px solid #666666;
`;

const StatNumber = styled.div`
  font-size: 2.5rem;
  font-weight: 800;
  color: #666666;
  margin-bottom: 10px;
`;

const StatLabel = styled.div`
  font-size: 1rem;
  color: #666;
  font-weight: 600;
`;

// Composants pour les tableaux
const DataTable = styled.div`
  background: white;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  overflow: hidden;
`;

const TableHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
`;

const TableTitle = styled.h2`
  margin: 0;
  color: #333;
  font-size: 1.3rem;
`;

const TableActions = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 10px;
`;

const TableContainer = styled.div`
  max-height: 600px;
  overflow-y: auto;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: inherit;
`;

const TableHead = styled.thead`
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: white;
`;

const TableHeaderCell = styled.th`
  padding: 15px 12px;
  text-align: left;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #1a1a1a;
  
  &:first-child {
    border-top-left-radius: 8px;
  }
  
  &:last-child {
    border-top-right-radius: 8px;
  }
`;

const TableBody = styled.tbody``;

const TableRow = styled.tr`
  border-bottom: 1px solid #e9ecef;
  transition: background-color 0.3s ease;
  
  &:hover {
    background: #f8f9fa;
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

const TableCell = styled.td`
  padding: 15px 12px;
  vertical-align: top;
  font-size: 0.95rem;
  color: #333;
`;

const StatusBadge = styled.span<{ status: string }>`
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  display: inline-block;
  background: ${props => {
    switch (props.status) {
      case 'approuve': return '#d4edda';
      case 'en_attente': return '#fff3cd';
      case 'rejete': return '#f8d7da';
      default: return '#e9ecef';
    }
  }};
  color: ${props => {
    switch (props.status) {
      case 'approuve': return '#155724';
      case 'en_attente': return '#856404';
      case 'rejete': return '#721c24';
      default: return '#6c757d';
    }
  }};
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

const ActionButton = styled.button<{ variant: 'approve' | 'reject' | 'edit' | 'delete' }>`
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  gap: 4px;
  
  background: ${props => {
    switch (props.variant) {
      case 'approve': return 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)';
      case 'reject': return 'linear-gradient(135deg, #f44336 0%, #d32f2f 100%)';
      case 'edit': return 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)';
      case 'delete': return 'linear-gradient(135deg, #FF5722 0%, #E64A19 100%)';
      default: return '#6c757d';
    }
  }};
  color: white;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 10px rgba(0,0,0,0.2);
  }
`;

const EmptyState = styled.div`
  padding: 40px;
  text-align: center;
  color: #666;
`;

const EmptyIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 20px;
  color: #FF9800;
`;

const EmptyTitle = styled.h3`
  margin: 0 0 10px 0;
  color: #333;
`;

const EmptyText = styled.p`
  margin: 0;
  color: #666;
`;

const ErrorMessage = styled.div`
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  color: #721c24;
  padding: 18px 22px;
  border-radius: 15px;
  margin-bottom: 25px;
  border: 2px solid #f1aeb5;
  font-weight: 600;
  font-family: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(114, 28, 36, 0.1);
  
  &::before {
    content: '✕';
    font-size: 1.5rem;
    font-weight: 700;
    background: #721c24;
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
`;

const SuccessMessage = styled.div`
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  padding: 18px 22px;
  border-radius: 15px;
  margin-bottom: 25px;
  border: 2px solid #b8e0c2;
  font-weight: 600;
  font-family: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 12px rgba(21, 87, 36, 0.1);
  
  &::before {
    content: '✓';
    font-size: 1.5rem;
    font-weight: 700;
    background: #155724;
    color: white;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
`;

const LoadingSpinner = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
`;

// Composants pour la recherche et les filtres
const SearchContainer = styled.div`
  background: white;
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  margin-bottom: 20px;
`;

const SearchGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 15px;
  margin-bottom: 15px;
`;

const SearchField = styled.div`
  display: flex;
  flex-direction: column;
`;

const SearchLabel = styled.label`
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
`;

const SearchInput = styled.input`
  padding: 10px 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
  
  &:focus {
    outline: none;
    border-color: #666666;
  }
  
  &::placeholder {
    color: #999;
  }
`;

const SearchActions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  flex-wrap: wrap;
`;

const SearchButton = styled.button<{ variant?: 'primary' | 'secondary' | 'print' }>`
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 8px;
  
  background: ${props => {
    switch (props.variant) {
      case 'primary': return 'linear-gradient(135deg, #666666 0%, #888888 100%)';
      case 'print': return 'linear-gradient(135deg, #1976D2 0%, #2196F3 100%)';
      default: return 'linear-gradient(135deg, #757575 0%, #9E9E9E 100%)';
    }
  }};
  color: white;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
`;

const ResultsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

const ResultsCount = styled.div`
  font-size: 1rem;
  color: #666;
  font-weight: 500;
`;

// Nouveau tableau stylisé pour l'impression
const PrintableTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Arial', sans-serif;
  font-size: 12px;
  margin-top: 20px;
  
  th, td {
    padding: 8px 12px;
    text-align: left;
    border: 1px solid #ddd;
  }
  
  th {
    background: #666666;
    color: white;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
  }
  
  tr:nth-child(even) {
    background: #f9f9f9;
  }
  
  tr:hover {
    background: #f0f8f0;
  }
  
  @media print {
    font-size: 10px;
    page-break-inside: auto;
    
    th, td {
      padding: 6px 8px;
      border: 1px solid #000;
    }
    
    th {
      background: #1a1a1a !important;
      color: white !important;
      font-weight: bold;
      font-size: 10px;
      -webkit-print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
    
    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }
    
    /* Assurer que les lignes alternées sont visibles à l'impression */
    tr:nth-child(even) {
      background: #f5f5f5 !important;
    }
    
    /* Masquer les effets hover à l'impression */
    tr:hover {
      background: inherit !important;
    }
  }
`;

const PrintHeader = styled.div`
  text-align: center;
  margin-bottom: 20px;
  
  h1 {
    color: #666666;
    margin: 0;
    font-size: 24px;
  }
  
  p {
    margin: 5px 0;
    color: #666;
    font-size: 14px;
  }
  
  @media print {
    h1 { 
      font-size: 20px; 
      color: #666666 !important;
      margin-bottom: 10px;
    }
    p { 
      font-size: 12px; 
      color: #333 !important;
      margin: 3px 0;
    }
    
    /* Assurer que le header est bien visible */
    background: white !important;
    padding: 10px 0;
    border-bottom: 2px solid #666666;
  }
`;

const PrintContainer = styled.div`
  @media print {
    /* Masquer tout le contenu de la page */
    body * {
      visibility: hidden !important;
    }
    
    /* Afficher seulement le contenu d'impression */
    &, & * {
      visibility: visible !important;
    }
    
    /* Positionner le contenu d'impression */
    position: fixed !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 20px !important;
    background: white !important;
    z-index: 9999 !important;
    
    /* Masquer les éléments de navigation et autres */
    nav, header, footer, .sidebar, .main-content, button, .search-container {
      display: none !important;
    }
  }
`;

// Composants pour les modals d'approbation
const ModalOverlay = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: ${props => props.isOpen ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

const ApprovalModalContent = styled.div`
  background: white;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  width: 100%;
  max-width: 500px;
  margin: 20px;
`;

const ModalTitle = styled.h2`
  margin: 0 0 20px 0;
  color: #333;
  font-size: 1.5rem;
  text-align: center;
`;

const ModalDescription = styled.p`
  margin: 0 0 20px 0;
  color: #666;
  text-align: center;
  font-size: 1rem;
`;

const ModalForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ModalInput = styled.input`
  padding: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
  
  &:focus {
    outline: none;
    border-color: #666666;
  }
`;

const ModalActions = styled.div`
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  margin-top: 20px;
`;

const ModalButton = styled.button<{ variant: 'primary' | 'secondary' }>`
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
  
  background: ${props => props.variant === 'primary' 
    ? 'linear-gradient(135deg, #666666 0%, #888888 100%)' 
    : 'linear-gradient(135deg, #757575 0%, #9E9E9E 100%)'};
  color: white;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
  
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

// URL de base de l'API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://aikash.ci';

// Fonction pour construire l'URL complète des images
const buildImageUrl = (url: string): string => {
  // Si l'URL commence par /uploads/, c'est une image uploadée
  if (url.startsWith('/uploads/')) {
    return `${API_BASE_URL}${url}`;
  }
  // Sinon, c'est une image statique du frontend
  return url;
};

function AdminPanel() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [adminUser, setAdminUser] = useState<Admin | null>(null);
  const [activeTab, setActiveTab] = useState<AdminTab>('dashboard');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error', text: string } | null>(null);

  const INACTIVITY_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes
  const lastActivityRef = useRef<number>(Date.now());
  
  // États pour les données
  const [clubs, setClubs] = useState<Club[]>([]);
  const [athletes, setAthletes] = useState<Athlete[]>([]);
  const [pendingClubs, setPendingClubs] = useState<Club[]>([]);
  const [pendingAthletes, setPendingAthletes] = useState<Athlete[]>([]);
  
  // États pour la recherche et les filtres
  const [searchFilters, setSearchFilters] = useState({
    nom: '',
    prenom: '',
    ville: '',
    quartier: ''
  });
  const [filteredAthletes, setFilteredAthletes] = useState<Athlete[]>([]);
  const [filteredClubs, setFilteredClubs] = useState<Club[]>([]);
  const [showPrintPreview, setShowPrintPreview] = useState(false);
  
  // États pour l'authentification
  const [loginForm, setLoginForm] = useState<LoginForm>({
    email: '',
    password: ''
  });
  const [showLoginPassword, setShowLoginPassword] = useState(false);

  // État pour le menu mobile
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // État pour le modal d'approbation
  const [approvalModal, setApprovalModal] = useState<ApprovalModal>({
    isOpen: false,
    type: null,
    itemId: null,
    itemName: null,
    montantAdhesion: ''
  });

  // États pour la gestion des médias
  const [gestionView, setGestionView] = useState<GestionView>('main');
  const [mediaForm, setMediaForm] = useState<MediaForm>({
    title: '',
    description: '',
    url: '',
    thumbnail: '',
    duration: '',
    category: 'Compétitions'
  });
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [editingMedia, setEditingMedia] = useState<MediaItem | null>(null);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [uploadedThumbnail, setUploadedThumbnail] = useState<File | null>(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  // États pour la gestion des événements
  const [showEventModal, setShowEventModal] = useState(false);
  const [eventForm, setEventForm] = useState({
    titre: '',
    description: '',
    dateDebut: '',
    heureDebut: '',
    dateFin: '',
    heureFin: '',
    lieu: '',
    type: 'competition'
  });
  const [editingEvent, setEditingEvent] = useState<any>(null);

  // États pour le formulaire simplifié d'ajout de vidéos
  const [showSimpleVideoModal, setShowSimpleVideoModal] = useState(false);
  const [simpleVideoFile, setSimpleVideoFile] = useState<File | null>(null);
  const [simpleVideoDescription, setSimpleVideoDescription] = useState('');
  const [simpleVideoCategory, setSimpleVideoCategory] = useState('Compétitions');
  const [isSimpleVideoUploading, setIsSimpleVideoUploading] = useState(false);

  // État pour les vidéos (initialisé vide, sera rempli depuis l'API)
  const [videos, setVideos] = useState<MediaItem[]>([]);
  const [videosLoaded, setVideosLoaded] = useState(false);

  const [photos, setPhotos] = useState<MediaItem[]>([]);
  const [showSimpleImageModal, setShowSimpleImageModal] = useState(false);
  const [simpleImageFile, setSimpleImageFile] = useState<File | null>(null);
  const [simpleImageDescription, setSimpleImageDescription] = useState('');
  const [isSimpleImageUploading, setIsSimpleImageUploading] = useState(false);

  // État pour les événements
  const [evenements, setEvenements] = useState<any[]>([]);
  const [evenementsLoaded, setEvenementsLoaded] = useState(false);
  
  // État pour le filtre par année
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [filteredEvenements, setFilteredEvenements] = useState<any[]>([]);

  // États pour les filtres d'années par section
  const [selectedYearClubs, setSelectedYearClubs] = useState(new Date().getFullYear());
  const [selectedYearAthletes, setSelectedYearAthletes] = useState(new Date().getFullYear());
  const [selectedYearFinance, setSelectedYearFinance] = useState(new Date().getFullYear());
  const [selectedYearVideos, setSelectedYearVideos] = useState(new Date().getFullYear());
  const [selectedYearPhotos, setSelectedYearPhotos] = useState(new Date().getFullYear());

  // États pour la gestion des administrateurs
  const [admins, setAdmins] = useState<Admin[]>([]);
  const [showCreateAdminModal, setShowCreateAdminModal] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [selectedAdminForReset, setSelectedAdminForReset] = useState<Admin | null>(null);
  const [adminForm, setAdminForm] = useState({
    nom: '',
    prenom: '',
    dateNaissance: '',
    telephone: '',
    ville: '',
    civilite: 'Monsieur',
    email: '',
    password: ''
  });

  // États pour l'édition des clubs
  const [showEditClubModal, setShowEditClubModal] = useState(false);
  const [editingClub, setEditingClub] = useState<Club | null>(null);
  const [clubEditForm, setClubEditForm] = useState({
    nomClub: '',
    nomMaitre: '',
    prenomMaitre: '',
    grade: '',
    telephone: '',
    ville: '',
    quartier: ''
  });

  // États pour les données filtrées par année
  const [filteredClubsByYear, setFilteredClubsByYear] = useState<Club[]>([]);
  const [filteredAthletesByYear, setFilteredAthletesByYear] = useState<Athlete[]>([]);
  const [filteredVideosByYear, setFilteredVideosByYear] = useState<MediaItem[]>([]);
  const [filteredPhotosByYear, setFilteredPhotosByYear] = useState<MediaItem[]>([]);

  // Effet pour filtrer les événements quand l'année change
  useEffect(() => {
    if (evenements.length > 0) {
      filterEventsByYear(selectedYear);
    }
  }, [selectedYear, evenements]);

  // Effet pour filtrer les clubs quand l'année change
  useEffect(() => {
    if (clubs.length > 0) {
      filterClubsByYear(selectedYearClubs);
    }
  }, [selectedYearClubs, clubs]);

  // Effet pour filtrer les athlètes quand l'année change
  useEffect(() => {
    if (athletes.length > 0) {
      filterAthletesByYear(selectedYearAthletes);
    }
  }, [selectedYearAthletes, athletes]);

  // Effet pour filtrer les vidéos quand l'année change
  useEffect(() => {
    if (videos.length > 0) {
      filterVideosByYear(selectedYearVideos);
    }
  }, [selectedYearVideos, videos]);

  // Effet pour filtrer les photos quand l'année change
  useEffect(() => {
    if (photos.length > 0) {
      filterPhotosByYear(selectedYearPhotos);
    }
  }, [selectedYearPhotos, photos]);

  // Effet pour synchroniser le filtre d'année finance avec les athlètes
  useEffect(() => {
    if (athletes.length > 0) {
      filterFinanceAthletesByYear(selectedYearFinance);
    }
  }, [selectedYearFinance, athletes]);

  // Effet pour synchroniser le filtre d'année finance avec les clubs
  useEffect(() => {
    if (clubs.length > 0) {
      filterFinanceClubsByYear(selectedYearFinance);
    }
  }, [selectedYearFinance, clubs]);

  // Charger les administrateurs quand l'onglet est actif
  useEffect(() => {
    if (activeTab === 'admins' && adminUser?.role === 'super_admin') {
      loadAdmins();
    }
  }, [activeTab, adminUser]);

  // Authentification réelle
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      // Authentifier avec l'API
      const admin = await adminService.login(loginForm);
      
      // Sauvegarder les données d'authentification dans localStorage
      localStorage.setItem('adminUser', JSON.stringify(admin));
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('adminLastActivity', String(Date.now()));
      
      setAdminUser(admin);
      setIsAuthenticated(true);
      setMessage({ type: 'success', text: 'Connexion réussie!' });
      
      // Effacer le formulaire
      setLoginForm({ email: '', password: '' });
    } catch (error: any) {
      setMessage({ type: 'error', text: error.message || 'Erreur de connexion' });
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    // Supprimer les données d'authentification du localStorage
    localStorage.removeItem('adminUser');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('adminLastActivity');
    
    setIsAuthenticated(false);
    setAdminUser(null);
    setActiveTab('dashboard');
    setMessage({ type: 'success', text: 'Déconnexion réussie' });
  };

  const clearAuthAndRedirectHome = () => {
    localStorage.removeItem('adminUser');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('adminLastActivity');
    setIsAuthenticated(false);
    setAdminUser(null);
    setActiveTab('dashboard');
    navigate('/');
  };

  // Fonctions pour la gestion des administrateurs
  const loadAdmins = async () => {
    try {
      const allAdmins = await adminService.getAll();
      setAdmins(allAdmins);
    } catch (error: any) {
      console.error('Erreur lors du chargement des administrateurs:', error);
      setMessage({ type: 'error', text: error.message || 'Erreur lors du chargement des administrateurs' });
    }
  };

  const handleCreateAdmin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      // Générer un mot de passe aléatoire
      const randomPassword = Math.random().toString(36).slice(-12) + Math.random().toString(36).slice(-12).toUpperCase() + '123!';
      
      const adminData = {
        email: adminForm.email,
        password: randomPassword,
        nom: adminForm.nom,
        prenom: adminForm.prenom,
        telephone: adminForm.telephone,
        dateNaissance: adminForm.dateNaissance,
        ville: adminForm.ville,
        civilite: adminForm.civilite,
        role: 'admin' as const
      };

      await adminService.create(adminData);
      
      setMessage({ 
        type: 'success', 
        text: `Administrateur créé avec succès! Les identifiants ont été envoyés par email à ${adminForm.email}` 
      });
      
      // Réinitialiser le formulaire
      setAdminForm({
        nom: '',
        prenom: '',
        dateNaissance: '',
        telephone: '',
        ville: '',
        civilite: 'Monsieur',
        email: '',
        password: ''
      });
      
      setShowCreateAdminModal(false);
      await loadAdmins();
    } catch (error: any) {
      setMessage({ type: 'error', text: error.message || 'Erreur lors de la création de l\'administrateur' });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAdmin = async (id: string) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer cet administrateur ?')) {
      return;
    }
    
    try {
      await adminService.delete(id);
      setMessage({ type: 'success', text: 'Administrateur supprimé avec succès' });
      await loadAdmins();
    } catch (error: any) {
      setMessage({ type: 'error', text: error.message || 'Erreur lors de la suppression' });
    }
  };

  const handleResetPassword = async (password: string) => {
    if (!selectedAdminForReset) return;
    
    setLoading(true);
    try {
      await adminService.resetPassword(selectedAdminForReset.id, password);
      setNewPassword(password);
      setShowResetPasswordModal(false);
      setShowPasswordPopup(true);
    } catch (error: any) {
      setMessage({ type: 'error', text: error.message || 'Erreur lors de la réinitialisation du mot de passe' });
      setLoading(false);
    }
  };

  const copyPasswordToClipboard = () => {
    navigator.clipboard.writeText(newPassword).then(() => {
      setMessage({ type: 'success', text: 'Mot de passe copié dans le presse-papiers!' });
    }).catch(() => {
      setMessage({ type: 'error', text: 'Erreur lors de la copie du mot de passe' });
    });
  };

  // Charger les données
  const loadData = async () => {
    try {
      setLoading(true);
      console.log('🔄 Chargement des données...');
      
      const [allClubs, allAthletes, pendingClubsData, pendingAthletesData, videosData, imagesData, eventsData] = await Promise.all([
        clubService.getAll(),
        athleteService.getAll(),
        clubService.getPending(),
        athleteService.getPending(),
        videoService.getAllVideos(),
        imageService.getAllImages(),
        eventService.getAllEvents()
      ]);
      
      console.log('📊 Données récupérées:', {
        clubs: allClubs.length,
        athletes: allAthletes.length,
        pendingClubs: pendingClubsData.length,
        pendingAthletes: pendingAthletesData.length,
        videos: videosData.length,
        images: imagesData.length,
        events: eventsData.length
      });
      
      console.log('🏢 Clubs:', allClubs);
      console.log('🏃 Athlètes:', allAthletes);
      console.log('🎥 Vidéos:', videosData);
      console.log('📸 Images:', imagesData);
      
      setClubs(allClubs);
      setAthletes(allAthletes);
      setPendingClubs(pendingClubsData);
      setPendingAthletes(pendingAthletesData);
      
      // Initialiser les données filtrées par année
      setFilteredClubsByYear(allClubs);
      setFilteredAthletesByYear(allAthletes);
      
      // Appliquer les filtres par année finance
      filterFinanceClubsByYear(selectedYearFinance);
      filterFinanceAthletesByYear(selectedYearFinance);
      
      // Traiter les événements
      if (eventsData && eventsData.length > 0) {
        const formattedEvents = eventsData.map((event: any) => {
          // Les dates sont déjà au format ISO complet
          let dateDebut, dateFin;
          
          try {
            if (typeof event.dateDebut === 'string') {
              dateDebut = new Date(event.dateDebut);
            } else if (event.dateDebut instanceof Date) {
              dateDebut = event.dateDebut;
            } else {
              dateDebut = new Date();
            }
            
            if (typeof event.dateFin === 'string') {
              dateFin = new Date(event.dateFin);
            } else if (event.dateFin instanceof Date) {
              dateFin = event.dateFin;
            } else {
              dateFin = new Date();
            }
            
            // Vérifier que les dates sont valides
            if (isNaN(dateDebut.getTime()) || isNaN(dateFin.getTime())) {
              console.warn('Date invalide pour l\'événement:', event.titre, event.dateDebut, event.heureDebut);
              dateDebut = new Date();
              dateFin = new Date();
            }
          } catch (error) {
            console.error('Erreur lors du formatage des dates pour l\'événement:', event.titre, error);
            dateDebut = new Date();
            dateFin = new Date();
          }
          
          return {
            id: event.id,
            titre: event.titre,
            description: event.description,
            dateDebut,
            dateFin,
            lieu: event.lieu,
            type: event.type,
            statut: event.statut || 'planifie'
          };
        });
        setEvenements(formattedEvents);
        setEvenementsLoaded(true);
        // Appliquer le filtre par année par défaut
        filterEventsByYear(selectedYear);
      } else {
        setEvenements([]);
        setEvenementsLoaded(true);
        setFilteredEvenements([]);
      }
      
      // Traiter les vidéos
      console.log('Vidéos reçues de l\'API:', videosData);
      
      if (videosData && videosData.length > 0) {
        const formattedVideos = videosData.map((video: any) => {
          console.log('Traitement de la vidéo:', video);
          
          // Construire l'URL complète de la vidéo
          let videoUrl = video.url;
          if (video.url && video.url.startsWith('/uploads/')) {
            videoUrl = `${process.env.REACT_APP_API_URL || 'https://aikash.ci'}${video.url}`;
          }
          
          // Construire l'URL de la miniature
          let thumbnailUrl = video.thumbnail;
          if (video.thumbnail && video.thumbnail.startsWith('/uploads/')) {
            thumbnailUrl = `${process.env.REACT_APP_API_URL || 'https://aikash.ci'}${video.thumbnail}`;
          } else if (!video.thumbnail) {
            // Si pas de miniature, utiliser une image par défaut générique
            thumbnailUrl = 'https://via.placeholder.com/300x200/666666/ffffff?text=Video';
          }
          
          return {
            id: video.id,
            title: video.title,
            description: video.description,
            url: videoUrl,
            thumbnail: thumbnailUrl,
            duration: video.duration || '00:00',
            category: video.category || 'Compétitions',
            datePublication: video.date_publication ? new Date(video.date_publication) : new Date(),
            heurePublication: video.heure_publication || new Date().toLocaleTimeString('fr-FR', { 
              hour: '2-digit', 
              minute: '2-digit', 
              second: '2-digit' 
            }),
            type: 'video' as const
          };
        });
        
        console.log('Vidéos formatées:', formattedVideos);
        setVideos(formattedVideos);
        setVideosLoaded(true);
        setFilteredVideosByYear(formattedVideos);
      } else {
        console.log('Aucune vidéo trouvée dans l\'API');
        setVideos([]);
        setVideosLoaded(true);
        setFilteredVideosByYear([]);
      }

      // Traiter les images
      const formattedPhotos = imagesData.map((image: any) => ({
        id: image.id,
        title: image.title,
        description: image.description,
        url: buildImageUrl(image.url), // Construire l'URL complète
        category: image.category,
        datePublication: new Date(image.date_publication),
        type: 'photo' as const
      }));
      setPhotos(formattedPhotos);
      setFilteredPhotosByYear(formattedPhotos);
    } catch (error: any) {
      console.error('❌ Erreur lors du chargement des données:', error);
      setMessage({ type: 'error', text: error.message || 'Erreur lors du chargement des données' });
    } finally {
      setLoading(false);
    }
  };

  // Restaurer la session au refresh (Ctrl+F5) MAIS expirer après 30 min d'inactivité
  useEffect(() => {
    const storedAuth = localStorage.getItem('isAuthenticated');
    const storedUser = localStorage.getItem('adminUser');
    const storedLastActivity = localStorage.getItem('adminLastActivity');

    if (storedAuth === 'true' && storedUser && storedLastActivity) {
      const last = Number(storedLastActivity);
      const now = Date.now();
      const expired = !Number.isFinite(last) || now - last > INACTIVITY_TIMEOUT_MS;

      if (expired) {
        clearAuthAndRedirectHome();
        return;
      }

      try {
        const admin = JSON.parse(storedUser);
        setAdminUser(admin);
        setIsAuthenticated(true);
        lastActivityRef.current = last;
      } catch {
        clearAuthAndRedirectHome();
      }
    }
  }, []);

  // Timeout d'inactivité robuste : déconnexion après 30 min d'inactivité (synchronisé entre onglets)
  useEffect(() => {
    if (!isAuthenticated) return;

    let lastWrite = 0;
    const updateActivity = () => {
      const now = Date.now();
      lastActivityRef.current = now;
      
      // Throttle les écritures dans localStorage (toutes les 5 secondes max)
      if (now - lastWrite > 5000) {
        lastWrite = now;
        localStorage.setItem('adminLastActivity', String(now));
      }
    };

    // Écouter les changements de localStorage depuis d'autres onglets
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'adminLastActivity' && e.newValue) {
        lastActivityRef.current = Number(e.newValue);
      }
      // Si un autre onglet a déconnecté l'utilisateur
      if (e.key === 'isAuthenticated' && e.newValue === null) {
        setAdminUser(null);
        setIsAuthenticated(false);
        navigate('/');
      }
    };

    // Liste complète d'événements pour détecter l'activité
    const activityEvents: Array<keyof WindowEventMap> = [
      'mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 
      'click', 'pointermove', 'wheel'
    ];

    activityEvents.forEach(evt => window.addEventListener(evt, updateActivity, { passive: true }));
    window.addEventListener('storage', handleStorageChange);
    
    // Mettre à jour l'activité lors du retour sur l'onglet
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        updateActivity();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Initialisation
    updateActivity();

    // Vérification régulière de l'inactivité
    const interval = window.setInterval(() => {
      const now = Date.now();
      const storedLastActivity = Number(localStorage.getItem('adminLastActivity') || 0);
      
      // Utiliser le plus récent entre le local et le storage
      const lastActivity = Math.max(lastActivityRef.current, storedLastActivity);
      
      if (now - lastActivity > INACTIVITY_TIMEOUT_MS) {
        console.log('⏰ Session expirée pour inactivité (30 min)');
        clearAuthAndRedirectHome();
      }
    }, 10_000); // Vérifier toutes les 10 secondes pour plus de précision

    return () => {
      activityEvents.forEach(evt => window.removeEventListener(evt, updateActivity as any));
      window.removeEventListener('storage', handleStorageChange);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.clearInterval(interval);
    };
  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      loadData();
    }
  }, [isAuthenticated]);

  // Actions d'administration
  const handleApproveClub = (club: Club) => {
    setApprovalModal({
      isOpen: true,
      type: 'club',
      itemId: club.id,
      itemName: club.nomClub,
      montantAdhesion: ''
    });
  };

  const handleApproveAthlete = (athlete: Athlete) => {
    setApprovalModal({
      isOpen: true,
      type: 'athlete',
      itemId: athlete.id,
      itemName: `${athlete.prenom} ${athlete.nom}`,
      montantAdhesion: ''
    });
  };

  const handleApprovalSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!approvalModal.montantAdhesion || parseFloat(approvalModal.montantAdhesion) <= 0) {
      setMessage({ type: 'error', text: 'Le montant d\'adhésion est obligatoire et doit être supérieur à 0' });
      return;
    }

    const montantAdhesion = parseFloat(approvalModal.montantAdhesion);
    
    try {
      setLoading(true);
      
      if (approvalModal.type === 'club' && approvalModal.itemId) {
        await clubService.approve(approvalModal.itemId, montantAdhesion);
        setMessage({ type: 'success', text: 'Club approuvé avec succès' });
      } else if (approvalModal.type === 'athlete' && approvalModal.itemId) {
        await athleteService.approve(approvalModal.itemId, montantAdhesion);
        setMessage({ type: 'success', text: 'Athlète approuvé avec succès' });
      }
      
      // Fermer le modal et recharger les données
      setApprovalModal({
        isOpen: false,
        type: null,
        itemId: null,
        itemName: null,
        montantAdhesion: ''
      });
      
      await loadData();
    } catch (error: any) {
      setMessage({ type: 'error', text: error.message || 'Erreur lors de l\'approbation' });
    } finally {
      setLoading(false);
    }
  };

  const handleApprovalCancel = () => {
    setApprovalModal({
      isOpen: false,
      type: null,
      itemId: null,
      itemName: null,
      montantAdhesion: ''
    });
  };

  // Formater la date
  const formatDate = (dateString: string | Date) => {
    const date = typeof dateString === 'string' ? new Date(dateString) : dateString;
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Fonctions de recherche et de filtrage pour les athlètes
  const handleSearch = () => {
    const filtered = athletes.filter(athlete => {
      const matchNom = !searchFilters.nom || 
        athlete.nom.toLowerCase().includes(searchFilters.nom.toLowerCase());
      const matchPrenom = !searchFilters.prenom || 
        athlete.prenom.toLowerCase().includes(searchFilters.prenom.toLowerCase());
      const matchVille = !searchFilters.ville || 
        athlete.situationGeographique.toLowerCase().includes(searchFilters.ville.toLowerCase());
      const matchQuartier = !searchFilters.quartier || 
        athlete.quartier.toLowerCase().includes(searchFilters.quartier.toLowerCase());
      
      return matchNom && matchPrenom && matchVille && matchQuartier;
    });
    
    setFilteredAthletes(filtered);
    
    // Appliquer aussi le filtre par année
    const filteredByYear = filtered.filter(athlete => {
      if (athlete.dateCreation) {
        const date = new Date(athlete.dateCreation);
        return !isNaN(date.getTime()) && date.getFullYear() === selectedYearAthletes;
      }
      return false;
    });
    setFilteredAthletesByYear(filteredByYear);
  };

  const handleClearSearch = () => {
    setSearchFilters({ nom: '', prenom: '', ville: '', quartier: '' });
    setFilteredAthletes(athletes);
    // Réappliquer le filtre par année
    filterAthletesByYear(selectedYearAthletes);
  };

  // Fonctions de recherche et de filtrage pour les clubs
  const handleSearchClubs = () => {
    const filtered = clubs.filter(club => {
      const matchNom = !searchFilters.nom || 
        club.nomClub.toLowerCase().includes(searchFilters.nom.toLowerCase());
      const matchMaitre = !searchFilters.prenom || 
        (club.prenomMaitre + ' ' + club.nomMaitre).toLowerCase().includes(searchFilters.prenom.toLowerCase());
      const matchVille = !searchFilters.ville || 
        club.ville.toLowerCase().includes(searchFilters.ville.toLowerCase());
      const matchQuartier = !searchFilters.quartier || 
        club.quartier.toLowerCase().includes(searchFilters.quartier.toLowerCase());
      
      return matchNom && matchMaitre && matchVille && matchQuartier;
    });
    
    setFilteredClubs(filtered);
    
    // Appliquer aussi le filtre par année
    const filteredByYear = filtered.filter(club => {
      if (club.dateCreation) {
        const date = new Date(club.dateCreation);
        return !isNaN(date.getTime()) && date.getFullYear() === selectedYearClubs;
      }
      return false;
    });
    setFilteredClubsByYear(filteredByYear);
  };

  const handleClearSearchClubs = () => {
    setSearchFilters({ nom: '', prenom: '', ville: '', quartier: '' });
    setFilteredClubs(clubs);
    // Réappliquer le filtre par année
    filterClubsByYear(selectedYearClubs);
  };

  const handleDeleteAthlete = async (id: string) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cet athlète ?')) {
      try {
        await athleteService.delete(id);
        setMessage({ type: 'success', text: 'Athlète supprimé avec succès' });
        loadData();
      } catch (error: any) {
        setMessage({ type: 'error', text: error.message || 'Erreur lors de la suppression' });
      }
    }
  };

  const handleEditAthlete = (athlete: Athlete) => {
    // Pour l'instant, nous affichons juste un message
    // Dans une implémentation complète, cela ouvrirait un modal d'édition
    setMessage({ 
      type: 'success', 
      text: `Fonctionnalité d'édition pour ${athlete.prenom} ${athlete.nom} sera bientôt disponible` 
    });
  };

  const handleDeleteClub = async (id: string) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce club ?')) {
      try {
        await clubService.delete(id);
        setMessage({ type: 'success', text: 'Club supprimé avec succès' });
        loadData();
      } catch (error: any) {
        setMessage({ type: 'error', text: error.message || 'Erreur lors de la suppression' });
      }
    }
  };

  const handleEditClub = (club: Club) => {
    setEditingClub(club);
    setClubEditForm({
      nomClub: club.nomClub || '',
      nomMaitre: club.nomMaitre || '',
      prenomMaitre: club.prenomMaitre || '',
      grade: club.grade || '',
      telephone: club.telephone || '',
      ville: club.ville || '',
      quartier: club.quartier || ''
    });
    setShowEditClubModal(true);
  };

  const handleUpdateClub = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!editingClub) return;

    setLoading(true);
    try {
      await clubService.update(editingClub.id, clubEditForm);
      setMessage({ type: 'success', text: `Club "${clubEditForm.nomClub}" mis à jour avec succès` });
      setShowEditClubModal(false);
      setEditingClub(null);
      await loadData();
    } catch (error: any) {
      setMessage({ type: 'error', text: error.message || 'Erreur lors de la mise à jour du club' });
    } finally {
      setLoading(false);
    }
  };

  const handleRejectClub = async (id: string) => {
    if (window.confirm('Êtes-vous sûr de vouloir rejeter ce club ?')) {
      try {
        await clubService.reject(id);
        setMessage({ type: 'success', text: 'Club rejeté avec succès' });
        loadData();
      } catch (error: any) {
        setMessage({ type: 'error', text: error.message || 'Erreur lors du rejet' });
      }
    }
  };

  const handleRejectAthlete = async (id: string) => {
    if (window.confirm('Êtes-vous sûr de vouloir rejeter cet athlète ?')) {
      try {
        await athleteService.reject(id);
        setMessage({ type: 'success', text: 'Athlète rejeté avec succès' });
        loadData();
      } catch (error: any) {
        setMessage({ type: 'error', text: error.message || 'Erreur lors du rejet' });
      }
    }
  };

  // Fonction pour supprimer un événement
  const handleDeleteEvent = async (id: string) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cet événement ?')) {
      try {
        await eventService.deleteEvent(id);
        setMessage({ type: 'success', text: 'Événement supprimé avec succès' });
        loadData();
      } catch (error: any) {
        setMessage({ type: 'error', text: error.message || 'Erreur lors de la suppression de l\'événement' });
      }
    }
  };

  // Fonction pour supprimer une photo
  const handleDeletePhoto = async (id: string) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cette photo ?')) {
      try {
        await imageService.deleteImage(id);
        setMessage({ type: 'success', text: 'Photo supprimée avec succès' });
        loadData(); // Recharger les données pour mettre à jour l'affichage
      } catch (error: any) {
        setMessage({ type: 'error', text: error.message || 'Erreur lors de la suppression de la photo' });
      }
    }
  };

  // Fonction pour modifier un événement
  const handleEditEvent = (event: any) => {
    setEditingEvent(event);
    setEventForm({
      titre: event.titre,
      description: event.description,
      dateDebut: event.dateDebut.toISOString().split('T')[0],
      heureDebut: event.dateDebut.toTimeString().slice(0, 5),
      dateFin: event.dateFin.toISOString().split('T')[0],
      heureFin: event.dateFin.toTimeString().slice(0, 5),
      lieu: event.lieu,
      type: event.type
    });
    setShowEventModal(true);
  };

  // Fonction pour filtrer les événements par année
  const filterEventsByYear = (year: number) => {
    const filtered = evenements.filter(event => {
      const eventYear = event.dateDebut.getFullYear();
      return eventYear === year;
    });
    setFilteredEvenements(filtered);
  };

  // -----------------------------
  // Finance: filtrage par année d'approbation (fallback: dateCreation)
  // Règle: ne prendre en compte que les éléments approuvés avec montantAdhesion > 0
  // -----------------------------
  function getFinanceDate(item: any): Date | null {
    const raw =
      item?.dateApprobation ??
      item?.dateApproval ??
      item?.dateModification ??
      item?.dateValidation ??
      item?.dateCreation;

    if (!raw) return null;
    const d = raw instanceof Date ? raw : new Date(raw);
    if (isNaN(d.getTime())) return null;
    return d;
  }

  function isApprovedWithMontant(item: any): boolean {
    const montant = typeof item?.montantAdhesion === 'number' ? item.montantAdhesion : Number(item?.montantAdhesion);
    return item?.statut === 'approuve' && Number.isFinite(montant) && montant > 0;
  }

  function filterFinanceClubsByYear(year: number) {
    const filtered = clubs.filter((club: any) => {
      if (!isApprovedWithMontant(club)) return false;
      const d = getFinanceDate(club);
      return !!d && d.getFullYear() === year;
    });
    setFilteredClubsByYear(filtered);
  }

  function filterFinanceAthletesByYear(year: number) {
    const filtered = athletes.filter((athlete: any) => {
      if (!isApprovedWithMontant(athlete)) return false;
      const d = getFinanceDate(athlete);
      return !!d && d.getFullYear() === year;
    });
    setFilteredAthletesByYear(filtered);
  }

  function getAvailableYearsFinance(): number[] {
    const years = new Set<number>();
    clubs.forEach((club: any) => {
      if (!isApprovedWithMontant(club)) return;
      const d = getFinanceDate(club);
      if (d) years.add(d.getFullYear());
    });
    athletes.forEach((athlete: any) => {
      if (!isApprovedWithMontant(athlete)) return;
      const d = getFinanceDate(athlete);
      if (d) years.add(d.getFullYear());
    });
    return Array.from(years).sort((a, b) => b - a);
  }

  // Fonction pour filtrer les clubs par année
  const filterClubsByYear = (year: number) => {
    const filtered = clubs.filter(club => {
      if (club.dateCreation) {
        const date = new Date(club.dateCreation);
        return !isNaN(date.getTime()) && date.getFullYear() === year;
      }
      return false;
    });
    setFilteredClubsByYear(filtered);
  };

  // Fonction pour filtrer les athlètes par année
  const filterAthletesByYear = (year: number) => {
    const filtered = athletes.filter(athlete => {
      if (athlete.dateCreation) {
        const date = new Date(athlete.dateCreation);
        return !isNaN(date.getTime()) && date.getFullYear() === year;
      }
      return false;
    });
    setFilteredAthletesByYear(filtered);
  };

  // Fonction pour filtrer les vidéos par année
  const filterVideosByYear = (year: number) => {
    const filtered = videos.filter(video => {
      if (video.datePublication) {
        const date = new Date(video.datePublication);
        return !isNaN(date.getTime()) && date.getFullYear() === year;
      }
      return false;
    });
    setFilteredVideosByYear(filtered);
  };

  // Fonction pour filtrer les photos par année
  const filterPhotosByYear = (year: number) => {
    const filtered = photos.filter(photo => {
      if (photo.datePublication) {
        const date = new Date(photo.datePublication);
        return !isNaN(date.getTime()) && date.getFullYear() === year;
      }
      return false;
    });
    setFilteredPhotosByYear(filtered);
  };

  // Fonction pour obtenir toutes les années disponibles
  const getAvailableYears = () => {
    const years = new Set<number>();
    evenements.forEach(event => {
      if (event.dateDebut instanceof Date && !isNaN(event.dateDebut.getTime())) {
        years.add(event.dateDebut.getFullYear());
      }
    });
    return Array.from(years).sort((a, b) => b - a); // Tri décroissant
  };

  // Fonction pour obtenir les années disponibles pour les clubs
  const getAvailableYearsClubs = () => {
    const years = new Set<number>();
    clubs.forEach(club => {
      if (club.dateCreation) {
        const date = new Date(club.dateCreation);
        if (!isNaN(date.getTime())) {
          years.add(date.getFullYear());
        }
      }
    });
    return Array.from(years).sort((a, b) => b - a); // Tri décroissant
  };

  // Fonction pour obtenir les années disponibles pour les athlètes
  const getAvailableYearsAthletes = () => {
    const years = new Set<number>();
    athletes.forEach(athlete => {
      if (athlete.dateCreation) {
        const date = new Date(athlete.dateCreation);
        if (!isNaN(date.getTime())) {
          years.add(date.getFullYear());
        }
      }
    });
    return Array.from(years).sort((a, b) => b - a); // Tri décroissant
  };

  // Fonction pour obtenir les années disponibles pour les vidéos
  const getAvailableYearsVideos = () => {
    const years = new Set<number>();
    videos.forEach(video => {
      if (video.datePublication) {
        const date = new Date(video.datePublication);
        if (!isNaN(date.getTime())) {
          years.add(date.getFullYear());
        }
      }
    });
    return Array.from(years).sort((a, b) => b - a); // Tri décroissant
  };

  // Fonction pour obtenir les années disponibles pour les photos
  const getAvailableYearsPhotos = () => {
    const years = new Set<number>();
    photos.forEach(photo => {
      if (photo.datePublication) {
        const date = new Date(photo.datePublication);
        if (!isNaN(date.getTime())) {
          years.add(date.getFullYear());
        }
      }
    });
    return Array.from(years).sort((a, b) => b - a); // Tri décroissant
  };

  // Fonctions pour l'upload de fichiers
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>, type: 'media' | 'thumbnail') => {
    const file = event.target.files?.[0];
    if (file) {
      if (type === 'media') {
        setUploadedFile(file);
        // Générer une URL temporaire pour l'aperçu
        const url = URL.createObjectURL(file);
        setMediaForm(prev => ({ ...prev, url }));
      } else {
        setUploadedThumbnail(file);
        // Générer une URL temporaire pour l'aperçu
        const url = URL.createObjectURL(file);
        setMediaForm(prev => ({ ...prev, thumbnail: url }));
      }
    }
  };

  const simulateUpload = async () => {
    setIsUploading(true);
    setUploadProgress(0);
    
    // Simulation d'un upload progressif
    for (let i = 0; i <= 100; i += 10) {
      await new Promise(resolve => setTimeout(resolve, 100));
      setUploadProgress(i);
    }
    
    setIsUploading(false);
    setUploadProgress(0);
    
    // Simuler un délai pour le traitement
    await new Promise(resolve => setTimeout(resolve, 500));
    
    return true;
  };

  const handleMediaSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!mediaForm.title) {
      setMessage({ type: 'error', text: 'Le titre est obligatoire' });
      return;
    }

    try {
      setIsUploading(true);
      
      if (editingMedia) {
        // Mode modification
        if (gestionView === 'videos') {
          // Modifier une vidéo
          await videoService.updateVideo(editingMedia.id, uploadedFile || undefined, {
            title: mediaForm.title,
            description: mediaForm.description,
            category: mediaForm.category
          });
        } else {
          // Modifier une image
          await imageService.updateImage(editingMedia.id, uploadedFile || undefined, {
            title: mediaForm.title,
            description: mediaForm.description,
            category: mediaForm.category
          });
        }
        
        setMessage({ type: 'success', text: 'Média modifié avec succès !' });
      } else {
        // Mode ajout (logique existante)
        if (!mediaForm.url && !uploadedFile) {
          setMessage({ type: 'error', text: 'Le fichier média est obligatoire pour l\'ajout' });
          return;
        }
        
        // Simuler l'upload si un fichier a été sélectionné
        if (uploadedFile || uploadedThumbnail) {
          await simulateUpload();
        }
        
        setMessage({ type: 'success', text: 'Média ajouté avec succès !' });
      }
      
      // Recharger les données pour mettre à jour l'affichage
      loadData();
      
      setShowMediaModal(false);
      setEditingMedia(null);
      setMediaForm({
        title: '',
        description: '',
        url: '',
        thumbnail: '',
        duration: '',
        category: 'Compétitions'
      });
      setUploadedFile(null);
      setUploadedThumbnail(null);
    } catch (error: any) {
      setMessage({ type: 'error', text: error.message || 'Erreur lors de l\'opération' });
    } finally {
      setIsUploading(false);
    }
  };

  // Fonction pour l'upload simplifié de vidéos
  const handleSimpleVideoUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log('📁 handleSimpleVideoUpload appelé');
    const file = event.target.files?.[0];
    console.log('📄 Fichier sélectionné:', file);
    
    if (file) {
      console.log('📊 Détails du fichier:', {
        name: file.name,
        size: file.size,
        type: file.type
      });
      
      // Vérifier le type de fichier
      if (!file.type.startsWith('video/')) {
        console.log('❌ Type de fichier invalide:', file.type);
        setMessage({ type: 'error', text: 'Veuillez sélectionner un fichier vidéo valide' });
        return;
      }
      
      // Vérifier la taille (1 Go max)
      const MAX_VIDEO_SIZE_BYTES = 1024 * 1024 * 1024; // 1 Go
      if (file.size > MAX_VIDEO_SIZE_BYTES) {
        console.log('❌ Fichier trop volumineux:', file.size);
        setMessage({ type: 'error', text: 'Le fichier est trop volumineux (max 1 Go)' });
        return;
      }
      
      console.log('✅ Fichier validé, ouverture du modal');
      setSimpleVideoFile(file);
      setShowSimpleVideoModal(true);
    } else {
      console.log('❌ Aucun fichier sélectionné');
    }
  };

  // Fonction pour soumettre la vidéo simplifiée
  const handleSimpleVideoSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    console.log('🎬 handleSimpleVideoSubmit appelé');
    console.log('📁 simpleVideoFile:', simpleVideoFile);
    console.log('📝 simpleVideoDescription:', simpleVideoDescription);
    console.log('📂 simpleVideoCategory:', simpleVideoCategory);
    
    if (!simpleVideoFile || !simpleVideoDescription.trim()) {
      console.log('❌ Validation échouée - fichier ou description manquant');
      setMessage({ type: 'error', text: 'Veuillez fournir une description pour la vidéo' });
      return;
    }

    try {
      setIsSimpleVideoUploading(true);
      
      // Créer les données de la vidéo pour l'API
      const videoData = {
        title: simpleVideoFile.name.replace(/\.[^/.]+$/, ''), // Nom du fichier sans extension
        description: simpleVideoDescription,
        duration: '00:00', // Durée par défaut
        category: simpleVideoCategory // Utiliser la catégorie sélectionnée
      };
      
      // Ajouter la vidéo à la base de données via l'API avec upload de fichier
      const savedVideo = await videoService.addVideo(simpleVideoFile, videoData);
      
      console.log('Vidéo sauvegardée:', savedVideo);
      
      // Créer un objet vidéo pour l'affichage local
      const newVideo: MediaItem = {
        id: savedVideo.id,
        title: savedVideo.title,
        description: savedVideo.description,
        url: savedVideo.url,
        thumbnail: savedVideo.thumbnail || 'https://via.placeholder.com/300x200/666666/ffffff?text=Video',
        duration: savedVideo.duration || '00:00',
        category: savedVideo.category,
        datePublication: new Date(savedVideo.date_publication),
        heurePublication: savedVideo.heure_publication,
        type: 'video'
      };
      
      console.log('Nouvelle vidéo formatée:', newVideo);
      
      // Ajouter la vidéo à la liste locale (en évitant les doublons)
      setVideos(prevVideos => {
        // Vérifier si la vidéo existe déjà
        const exists = prevVideos.some(v => v.id === newVideo.id || v.url === newVideo.url);
        if (exists) {
          console.log('⚠️ Vidéo déjà présente, pas de duplication');
          return prevVideos;
        }
        console.log('✅ Nouvelle vidéo ajoutée à la liste locale:', newVideo);
        return [newVideo, ...prevVideos];
      });
      
      setMessage({ 
        type: 'success', 
        text: 'Vidéo ajoutée avec succès ! Elle sera visible dans la galerie.' 
      });
      
      // Fermer le modal et réinitialiser
      setShowSimpleVideoModal(false);
      setSimpleVideoFile(null);
      setSimpleVideoDescription('');
      setSimpleVideoCategory('Compétitions');
      
      // Recharger les données depuis l'API après un délai
      setTimeout(async () => {
        try {
          console.log('🔄 Rechargement des données...');
          await loadData();
          console.log('✅ Données rechargées avec succès');
        } catch (error) {
          console.error('❌ Erreur lors du rechargement des données:', error);
        }
      }, 2000);
      
    } catch (error: any) {
      console.error('Erreur lors de l\'ajout de la vidéo:', error);
      setMessage({ 
        type: 'error', 
        text: error.message || 'Erreur lors de l\'ajout de la vidéo. Vérifiez que le serveur backend est démarré.' 
      });
      // Fermer le modal même en cas d'erreur pour permettre à l'utilisateur de réessayer
      setShowSimpleVideoModal(false);
      setSimpleVideoFile(null);
      setSimpleVideoDescription('');
    } finally {
      setIsSimpleVideoUploading(false);
    }
  };

  // Fonction pour gérer la sélection d'image
  const handleImageSelect = (file: File) => {
    setSimpleImageFile(file);
    setShowSimpleImageModal(true);
  };

  // Fonction pour soumettre l'image simplifiée
  const handleSimpleImageSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!simpleImageFile || !simpleImageDescription.trim()) {
      setMessage({ type: 'error', text: 'Veuillez fournir une description pour l\'image' });
      return;
    }

    try {
      setIsSimpleImageUploading(true);
      
      // Créer les données de l'image pour l'API
      const imageData = {
        title: simpleImageFile.name.replace(/\.[^/.]+$/, ''), // Nom du fichier sans extension
        description: simpleImageDescription,
        category: 'Événements'
      };
      
      // Ajouter l'image à la base de données via l'API avec upload de fichier
      const savedImage = await imageService.addImage(simpleImageFile, imageData);
      
      // Créer un objet image pour l'affichage local
      const newImage: MediaItem = {
        id: savedImage.id,
        title: savedImage.title,
        description: savedImage.description,
        url: savedImage.url,
        category: savedImage.category,
        datePublication: new Date(savedImage.date_publication),
        heurePublication: savedImage.heure_publication || new Date().toLocaleTimeString('fr-FR', { 
          hour: '2-digit', 
          minute: '2-digit', 
          second: '2-digit' 
        }),
        type: 'photo'
      };
      
      // Ajouter l'image à la liste locale
      setPhotos(prevPhotos => [newImage, ...prevPhotos]);
      
      setMessage({ 
        type: 'success', 
        text: 'Image ajoutée avec succès ! Elle sera visible dans la galerie.' 
      });
      
      // Fermer le modal et réinitialiser IMMÉDIATEMENT après succès
      setShowSimpleImageModal(false);
      setSimpleImageFile(null);
      setSimpleImageDescription('');
      
      // Rafraîchir la page après 2 secondes pour que l'image soit visible
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      
    } catch (error: any) {
      console.error('Erreur lors de l\'ajout de l\'image:', error);
      setMessage({ 
        type: 'error', 
        text: error.message || 'Erreur lors de l\'ajout de l\'image. Vérifiez que le serveur backend est démarré.' 
      });
      // Fermer le modal même en cas d'erreur pour permettre à l'utilisateur de réessayer
      setShowSimpleImageModal(false);
      setSimpleImageFile(null);
      setSimpleImageDescription('');
    } finally {
      setIsSimpleImageUploading(false);
    }
  };

  const handlePrint = () => {
    // Générer un titre dynamique basé sur les filtres
    const getPrintTitle = () => {
      const filters = [];
      if (searchFilters.nom) filters.push(`nom "${searchFilters.nom}"`);
      if (searchFilters.prenom) filters.push(`prénom "${searchFilters.prenom}"`);
      if (searchFilters.ville) filters.push(`ville "${searchFilters.ville}"`);
      if (searchFilters.quartier) filters.push(`quartier "${searchFilters.quartier}"`);
      
      if (filters.length === 0) {
        return "Liste des Athlètes Approuvés";
      } else {
        return `Liste des Athlètes Approuvés - Filtre: ${filters.join(', ')}`;
      }
    };

    // Créer une nouvelle fenêtre pour l'impression
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      const printContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>${getPrintTitle()} - Shotokan Karaté Club</title>
          <style>
            @page {
              margin: 1cm;
              size: A4;
            }
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 20px;
              background: white;
            }
            .header {
              text-align: center;
              margin-bottom: 30px;
              border-bottom: 2px solid #666666;
              padding-bottom: 20px;
            }
            .header h1 {
              color: #666666;
              margin: 0 0 10px 0;
              font-size: 24px;
            }
            .header p {
              margin: 5px 0;
              color: #333;
              font-size: 14px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
              font-size: 12px;
            }
            th, td {
              border: 1px solid #000;
              padding: 8px;
              text-align: left;
            }
            th {
              background: #1a1a1a !important;
              color: white !important;
              font-weight: bold;
              font-size: 11px;
              text-transform: uppercase;
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
            tr:nth-child(even) {
              background: #f5f5f5;
            }
            @media print {
              body { margin: 0; }
              .header { margin-bottom: 20px; }
              table { font-size: 10px; }
              th, td { padding: 6px; }
              th {
                background: #1a1a1a !important;
                color: white !important;
                -webkit-print-color-adjust: exact !important;
                color-adjust: exact !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="logo-container" style="display: flex; align-items: center; justify-content: center; margin-bottom: 15px;">
              <img src="/logo.jpg" alt="Logo Shotokan" width="70" height="70" style="margin-right: 15px; object-fit: cover; border-radius: 50%;" />
              <h1 style="color: #666666; margin: 0; font-size: 24px; font-weight: 700;">SHOTOKAN KARATÉ CLUB</h1>
            </div>
            <p>${getPrintTitle()}</p>
            <p>Généré le ${new Date().toLocaleDateString('fr-FR')} à ${new Date().toLocaleTimeString('fr-FR')}</p>
            <p>Nombre total d'athlètes : ${filteredAthletes.length}</p>
          </div>
          <table>
            <thead>
              <tr>
                <th>Nom</th>
                <th>Prénom</th>
                <th>Téléphone</th>
                <th>Ville</th>
                 <th>Quartier</th>
                 <th>Grade</th>
                <th>Date de naissance</th>
                <th>Club</th>
                <th>Contact d'urgence</th>
                <th>Date d'inscription</th>
              </tr>
            </thead>
            <tbody>
              ${filteredAthletes.map(athlete => `
                <tr>
                  <td>${athlete.nom}</td>
                  <td>${athlete.prenom}</td>
                  <td>${athlete.telephone}</td>
                  <td>${athlete.situationGeographique}</td>
                   <td>${athlete.quartier}</td>
                   <td>${athlete.grade}</td>
                  <td>${new Date(athlete.dateNaissance).toLocaleDateString('fr-FR')}</td>
                   <td>${athlete.clubSouhaite || 'N/A'}</td>
                  <td>${athlete.contactUrgence.prenom} ${athlete.contactUrgence.nom} - ${athlete.contactUrgence.telephone}</td>
                  <td>${formatDate(athlete.dateCreation)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
        </html>
      `;
      
      printWindow.document.write(printContent);
      printWindow.document.close();
      
      printWindow.onload = () => {
        printWindow.print();
        printWindow.close();
      };
    }
  };

  const handlePrintClubs = () => {
    // Générer un titre dynamique basé sur les filtres
    const getPrintTitle = () => {
      const filters = [];
      if (searchFilters.nom) filters.push(`nom "${searchFilters.nom}"`);
      if (searchFilters.prenom) filters.push(`maître "${searchFilters.prenom}"`);
      if (searchFilters.ville) filters.push(`ville "${searchFilters.ville}"`);
      if (searchFilters.quartier) filters.push(`quartier "${searchFilters.quartier}"`);
      
      if (filters.length === 0) {
        return "Liste des Clubs Approuvés";
      } else {
        return `Liste des Clubs Approuvés - Filtre: ${filters.join(', ')}`;
      }
    };

    // Créer une nouvelle fenêtre pour l'impression
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      const printContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>${getPrintTitle()} - Shotokan Karaté Club</title>
          <style>
            @page {
              margin: 1cm;
              size: A4;
            }
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 20px;
              background: white;
            }
            .header {
              text-align: center;
              margin-bottom: 30px;
              border-bottom: 2px solid #666666;
              padding-bottom: 20px;
            }
            .header h1 {
              color: #666666;
              margin: 0 0 10px 0;
              font-size: 24px;
            }
            .header p {
              margin: 5px 0;
              color: #333;
              font-size: 14px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
              font-size: 12px;
            }
            th, td {
              border: 1px solid #000;
              padding: 8px;
              text-align: left;
            }
            th {
              background: #1a1a1a !important;
              color: white !important;
              font-weight: bold;
              font-size: 11px;
              text-transform: uppercase;
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
            tr:nth-child(even) {
              background: #f5f5f5;
            }
            @media print {
              body { margin: 0; }
              .header { margin-bottom: 20px; }
              table { font-size: 10px; }
              th, td { padding: 6px; }
              th {
                background: #1a1a1a !important;
                color: white !important;
                -webkit-print-color-adjust: exact !important;
                color-adjust: exact !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <div class="logo-container" style="display: flex; align-items: center; justify-content: center; margin-bottom: 15px;">
              <img src="/logo.jpg" alt="Logo Shotokan" width="70" height="70" style="margin-right: 15px; object-fit: cover; border-radius: 50%;" />
              <h1 style="color: #666666; margin: 0; font-size: 24px; font-weight: 700;">SHOTOKAN KARATÉ CLUB</h1>
            </div>
            <p>${getPrintTitle()}</p>
            <p>Généré le ${new Date().toLocaleDateString('fr-FR')} à ${new Date().toLocaleTimeString('fr-FR')}</p>
            <p>Nombre total de clubs : ${filteredClubs.length}</p>
          </div>
          <table>
            <thead>
              <tr>
                <th>Nom du Club</th>
                <th>Maître</th>
                <th>Grade</th>
                <th>Téléphone</th>
                <th>Ville</th>
                <th>Quartier</th>
                <th>Date d'inscription</th>
              </tr>
            </thead>
            <tbody>
              ${filteredClubs.map(club => `
                <tr>
                  <td>${club.nomClub}</td>
                  <td>${club.prenomMaitre} ${club.nomMaitre}</td>
                  <td>${club.grade}</td>
                  <td>${club.telephone}</td>
                  <td>${club.ville}</td>
                  <td>${club.quartier}</td>
                  <td>${formatDate(club.dateCreation)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
        </html>
      `;
      
      printWindow.document.write(printContent);
      printWindow.document.close();
      
      printWindow.onload = () => {
        printWindow.print();
        printWindow.close();
      };
    }
  };

  // Effet pour initialiser les résultats filtrés
  useEffect(() => {
    setFilteredAthletes(athletes);
  }, [athletes]);

  useEffect(() => {
    setFilteredClubs(clubs);
  }, [clubs]);

  // Effet pour réinitialiser la recherche quand on change d'onglet
  useEffect(() => {
    if (activeTab === 'finance') {
      setFilteredClubs(clubs);
      setSearchFilters({ nom: '', prenom: '', ville: '', quartier: '' });
    }
  }, [activeTab, clubs]);

  // Page de connexion
  if (!isAuthenticated) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
              background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
        padding: '20px'
      }}>
        <LoginContainer>
          <LoginCard>
            <LoginTitle><LockIcon /> Connexion Admin</LoginTitle>
            
            {message && (
              message.type === 'success' ? 
                <SuccessMessage>{message.text}</SuccessMessage> : 
                <ErrorMessage>{message.text}</ErrorMessage>
            )}
            
            <form onSubmit={handleLogin}>
              <FormGroup>
                <Label>Email</Label>
                <Input
                  type="email"
                  value={loginForm.email}
                  onChange={(e) => setLoginForm({...loginForm, email: e.target.value})}
                  required
                  placeholder="admin@shotokan.com"
                />
              </FormGroup>
              
              <FormGroup>
                <Label>Mot de passe</Label>
                <div style={{ position: 'relative' }}>
                  <Input
                    type={showLoginPassword ? 'text' : 'password'}
                    value={loginForm.password}
                    onChange={(e) => setLoginForm({...loginForm, password: e.target.value})}
                    required
                    placeholder="••••••••"
                    style={{ paddingRight: '52px' }}
                  />
                  <PasswordToggleButton
                    type="button"
                    onClick={() => setShowLoginPassword((v) => !v)}
                    aria-label={showLoginPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                    title={showLoginPassword ? 'Masquer' : 'Afficher'}
                  >
                    {showLoginPassword ? '🙈' : '👁️'}
                  </PasswordToggleButton>
                </div>
              </FormGroup>
              
              <LoginButton type="submit" disabled={loading}>
                {loading ? 'Connexion...' : 'Se connecter'}
              </LoginButton>
            </form>

            <button
              onClick={() => window.location.href = '/'}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                width: '100%',
                marginTop: '12px',
                padding: '12px 20px',
                background: 'transparent',
                border: '2px solid #e0e0e0',
                borderRadius: '12px',
                color: '#555',
                fontSize: '0.95rem',
                fontWeight: 600,
                fontFamily: "'Inter', 'Segoe UI', 'Roboto', sans-serif",
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLButtonElement).style.background = '#f5f5f5';
                (e.currentTarget as HTMLButtonElement).style.borderColor = '#bbb';
                (e.currentTarget as HTMLButtonElement).style.color = '#222';
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLButtonElement).style.background = 'transparent';
                (e.currentTarget as HTMLButtonElement).style.borderColor = '#e0e0e0';
                (e.currentTarget as HTMLButtonElement).style.color = '#555';
              }}
            >
              ← Retour à l'accueil
            </button>
            
          </LoginCard>
        </LoginContainer>
      </div>
    );
  }

  // Tableau de bord administrateur
  return (
    <AdminContainer>
      <AdminNavbar>
        <NavbarLeft>
          <NavbarLogo>
            <DashboardIcon />
            <NavbarTitle>Shotokan Karaté Club</NavbarTitle>
          </NavbarLogo>
        </NavbarLeft>
        
        <NavbarUser>
          <UserInfo>
            <UserName>{adminUser?.prenom} {adminUser?.nom}</UserName>
            <UserRole>Principal Administrateur</UserRole>
          </UserInfo>
        </NavbarUser>
        
        <NavbarActions>
          <NavbarButton onClick={() => window.location.href = '/'}>
            ← RETOUR À L'ACCUEIL
          </NavbarButton>
          <NavbarButton>
            🔒 ADMINISTRATION
          </NavbarButton>
        </NavbarActions>
         
         <MobileMenuButton onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
           {isMobileMenuOpen ? <CloseIcon /> : <MenuToggleIcon />}
         </MobileMenuButton>
      </AdminNavbar>
      
             <MobileOverlay isOpen={isMobileMenuOpen} onClick={() => setIsMobileMenuOpen(false)} />
       <Sidebar isOpen={isMobileMenuOpen}>
        <SidebarHeader>
          <AdminName>{adminUser?.prenom} {adminUser?.nom}</AdminName>
          <AdminEmail>{adminUser?.email}</AdminEmail>
        </SidebarHeader>
        
        <SidebarMenu>
          <MenuItem 
            active={activeTab === 'dashboard'} 
           onClick={() => {
             setActiveTab('dashboard');
             setIsMobileMenuOpen(false);
           }}
          >
            <MenuIcon><DashboardIcon /></MenuIcon>
            Tableau de bord
          </MenuItem>
          
          <MenuItem 
            active={activeTab === 'clubs'} 
           onClick={() => {
             setActiveTab('clubs');
             setIsMobileMenuOpen(false);
           }}
          >
            <MenuIcon><ClubIcon /></MenuIcon>
            Liste des clubs ({clubs.length})
          </MenuItem>
          
          <MenuItem 
            active={activeTab === 'athletes'} 
           onClick={() => {
             setActiveTab('athletes');
             setIsMobileMenuOpen(false);
           }}
          >
            <MenuIcon><AthleteIcon /></MenuIcon>
            Liste des athlètes ({athletes.length})
          </MenuItem>
          
          <MenuItem 
            active={activeTab === 'pending-clubs'} 
           onClick={() => {
             setActiveTab('pending-clubs');
             setIsMobileMenuOpen(false);
           }}
          >
            <MenuIcon><PendingIcon /></MenuIcon>
            Clubs à approuver ({pendingClubs.length})
          </MenuItem>
          
          <MenuItem 
            active={activeTab === 'pending-athletes'} 
           onClick={() => {
             setActiveTab('pending-athletes');
             setIsMobileMenuOpen(false);
           }}
          >
            <MenuIcon><PendingIcon /></MenuIcon>
            Athlètes à approuver ({pendingAthletes.length})
          </MenuItem>
          
          <MenuItem 
            active={activeTab === 'finance'} 
           onClick={() => {
             setActiveTab('finance');
             setIsMobileMenuOpen(false);
           }}
          >
            <MenuIcon><FinanceIcon /></MenuIcon>
            Finance et Comptabilité
          </MenuItem>
          
          <MenuItem 
            active={activeTab === 'gestions'} 
           onClick={() => {
             setActiveTab('gestions');
             setIsMobileMenuOpen(false);
           }}
          >
            <MenuIcon><SettingsIcon /></MenuIcon>
            Gestion
          </MenuItem>
          
          <MenuItem 
            active={activeTab === 'settings'} 
           onClick={() => {
             setActiveTab('settings');
             setIsMobileMenuOpen(false);
           }}
          >
            <MenuIcon><SettingsIcon /></MenuIcon>
            Paramètres
          </MenuItem>
          
          {adminUser?.role === 'super_admin' && (
            <MenuItem 
              active={activeTab === 'admins'} 
              onClick={() => {
                setActiveTab('admins');
                setIsMobileMenuOpen(false);
              }}
            >
              <MenuIcon><AdminUserIcon /></MenuIcon>
              Créer un Administrateur
            </MenuItem>
          )}
        </SidebarMenu>
        
                 <LogoutButton onClick={() => {
           handleLogout();
           setIsMobileMenuOpen(false);
         }}>
          <LogoutIcon /> Se déconnecter
        </LogoutButton>
         
         {/* Bouton de fermeture mobile */}
         <div style={{ display: 'none', padding: '20px', textAlign: 'center' }}>
           <MobileMenuButton onClick={() => setIsMobileMenuOpen(false)}>
             <CloseIcon /> Fermer le menu
           </MobileMenuButton>
         </div>
      </Sidebar>
      
      <MainContent>
        {message && (
          message.type === 'success' ? 
            <SuccessMessage>{message.text}</SuccessMessage> : 
            <ErrorMessage>{message.text}</ErrorMessage>
        )}
        
        {activeTab === 'dashboard' && (
          <>
            <PageHeader>
              <PageTitle><DashboardIcon /> Tableau de Bord</PageTitle>
              <PageSubtitle>Vue d'ensemble de la gestion des affiliations</PageSubtitle>
            </PageHeader>
            
            <StatsGrid>
              <StatCard>
                <StatNumber>{clubs.length}</StatNumber>
                <StatLabel>Clubs Approuvés</StatLabel>
              </StatCard>
              <StatCard>
                <StatNumber>{athletes.length}</StatNumber>
                <StatLabel>Athlètes Approuvés</StatLabel>
              </StatCard>
              <StatCard>
                <StatNumber>{pendingClubs.length}</StatNumber>
                <StatLabel>Clubs en Attente</StatLabel>
              </StatCard>
              <StatCard>
                <StatNumber>{pendingAthletes.length}</StatNumber>
                <StatLabel>Athlètes en Attente</StatLabel>
              </StatCard>
               <StatCard>
                 <StatNumber>{clubs.filter(c => c.statut === 'rejete').length}</StatNumber>
                 <StatLabel>Clubs Rejetés</StatLabel>
               </StatCard>
               <StatCard>
                 <StatNumber>{athletes.filter(a => a.statut === 'rejete').length}</StatNumber>
                 <StatLabel>Athlètes Rejetés</StatLabel>
               </StatCard>
               <StatCard>
                 <StatNumber>{clubs.length + pendingClubs.length + clubs.filter(c => c.statut === 'rejete').length}</StatNumber>
                 <StatLabel>Total Clubs</StatLabel>
               </StatCard>
               <StatCard>
                 <StatNumber>{athletes.length + pendingAthletes.length + athletes.filter(a => a.statut === 'rejete').length}</StatNumber>
                 <StatLabel>Total Athlètes</StatLabel>
              </StatCard>
            </StatsGrid>

                           {/* Graphiques d'analyse */}
             <Charts 
               clubs={clubs}
               athletes={athletes}
               pendingClubs={pendingClubs}
               pendingAthletes={pendingAthletes}
             />
          </>
        )}

        {activeTab === 'clubs' && (
          <>
            <PageHeader>
              <PageTitle><ClubIcon /> Liste des Clubs</PageTitle>
              <PageSubtitle>Rechercher et gérer tous les clubs approuvés</PageSubtitle>
            </PageHeader>

            {/* Section de recherche */}
            <SearchContainer>
              <SearchGrid>
                <SearchField>
                  <SearchLabel>Nom du Club</SearchLabel>
                  <SearchInput
                    type="text"
                    placeholder="Rechercher par nom de club..."
                    value={searchFilters.nom}
                    onChange={(e) => setSearchFilters({...searchFilters, nom: e.target.value})}
                  />
                </SearchField>
                <SearchField>
                  <SearchLabel>Maître</SearchLabel>
                  <SearchInput
                    type="text"
                    placeholder="Rechercher par nom du maître..."
                    value={searchFilters.prenom}
                    onChange={(e) => setSearchFilters({...searchFilters, prenom: e.target.value})}
                  />
                </SearchField>
                <SearchField>
                  <SearchLabel>Ville</SearchLabel>
                  <SearchInput
                    type="text"
                    placeholder="Rechercher par ville..."
                    value={searchFilters.ville}
                    onChange={(e) => setSearchFilters({...searchFilters, ville: e.target.value})}
                  />
                </SearchField>
                <SearchField>
                  <SearchLabel>Quartier</SearchLabel>
                  <SearchInput
                    type="text"
                    placeholder="Rechercher par quartier..."
                    value={searchFilters.quartier}
                    onChange={(e) => setSearchFilters({...searchFilters, quartier: e.target.value})}
                  />
                </SearchField>
                <SearchField>
                  <SearchLabel>Année</SearchLabel>
                  <YearFilter
                    selectedYear={selectedYearClubs}
                    onYearChange={setSelectedYearClubs}
                    availableYears={getAvailableYearsClubs()}
                    label=""
                  />
                </SearchField>
              </SearchGrid>
              <SearchActions>
                <SearchButton variant="primary" onClick={handleSearchClubs}>
                  <SearchIcon /> Rechercher
                </SearchButton>
                <SearchButton variant="secondary" onClick={handleClearSearchClubs}>
                  <ClearIcon /> Effacer
                </SearchButton>
                <SearchButton variant="print" onClick={handlePrintClubs}>
                  <PrintIcon /> Imprimer
                </SearchButton>
              </SearchActions>
            </SearchContainer>

            {/* Résultats */}
            <DataTable>
              <TableHeader>
                <ResultsHeader>
                  <TableTitle>Clubs Approuvés</TableTitle>
                  <ResultsCount>
                    {filteredClubsByYear.length} résultat{filteredClubsByYear.length > 1 ? 's' : ''} sur {clubs.length} (filtré par année {selectedYearClubs})
                  </ResultsCount>
                </ResultsHeader>
              </TableHeader>
              <TableContainer>
                {filteredClubsByYear.length === 0 ? (
                  <EmptyState>
                    <EmptyIcon><SearchIcon /></EmptyIcon>
                    <EmptyTitle>Aucun club trouvé pour l'année {selectedYearClubs}</EmptyTitle>
                    <EmptyText>Essayez de modifier l'année ou vos critères de recherche</EmptyText>
                  </EmptyState>
                ) : (
                  <StyledTable>
                    <TableHead>
                      <tr>
                        <TableHeaderCell>Nom du Club</TableHeaderCell>
                        <TableHeaderCell>Maître</TableHeaderCell>
                        <TableHeaderCell>Grade</TableHeaderCell>
                        <TableHeaderCell>Téléphone</TableHeaderCell>
                        <TableHeaderCell>Localisation</TableHeaderCell>
                        <TableHeaderCell>Montant d'adhésion</TableHeaderCell>
                        <TableHeaderCell>Date d'inscription</TableHeaderCell>
                        <TableHeaderCell>Statut</TableHeaderCell>
                        <TableHeaderCell>Actions</TableHeaderCell>
                      </tr>
                    </TableHead>
                    <TableBody>
                      {filteredClubsByYear.map(club => (
                        <TableRow key={club.id}>
                          <TableCell>
                            <strong>{club.nomClub}</strong>
                          </TableCell>
                          <TableCell>{club.prenomMaitre} {club.nomMaitre}</TableCell>
                          <TableCell>{club.grade}</TableCell>
                          <TableCell>{club.telephone}</TableCell>
                          <TableCell>{club.ville}, {club.quartier}</TableCell>
                          <TableCell>
                            {club.montantAdhesion ? `${club.montantAdhesion.toLocaleString('fr-FR')} FCFA` : 'Non défini'}
                          </TableCell>
                          <TableCell>{formatDate(club.dateCreation)}</TableCell>
                          <TableCell>
                            <StatusBadge status={club.statut}>
                              {club.statut === 'approuve' ? 'Approuvé' : club.statut}
                            </StatusBadge>
                          </TableCell>
                          <TableCell>
                            <ActionButtons>
                              <ActionButton 
                                variant="edit" 
                                onClick={() => handleEditClub(club)}
                              >
                                <EditIcon /> Modifier
                              </ActionButton>
                              <ActionButton 
                                variant="delete" 
                                onClick={() => handleDeleteClub(club.id)}
                              >
                                <DeleteIcon /> Supprimer
                              </ActionButton>
                            </ActionButtons>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </StyledTable>
                )}
              </TableContainer>
            </DataTable>


          </>
        )}
        
        {activeTab === 'athletes' && (
          <>
            <PageHeader>
              <PageTitle><AthleteIcon /> Liste des Athlètes</PageTitle>
              <PageSubtitle>Rechercher et gérer tous les athlètes approuvés</PageSubtitle>
            </PageHeader>

            {/* Section de recherche */}
            <SearchContainer>
              <SearchGrid>
                <SearchField>
                  <SearchLabel>Nom</SearchLabel>
                  <SearchInput
                    type="text"
                    placeholder="Rechercher par nom..."
                    value={searchFilters.nom}
                    onChange={(e) => setSearchFilters({...searchFilters, nom: e.target.value})}
                  />
                </SearchField>
                <SearchField>
                  <SearchLabel>Prénom</SearchLabel>
                  <SearchInput
                    type="text"
                    placeholder="Rechercher par prénom..."
                    value={searchFilters.prenom}
                    onChange={(e) => setSearchFilters({...searchFilters, prenom: e.target.value})}
                  />
                </SearchField>
                <SearchField>
                  <SearchLabel>Ville</SearchLabel>
                  <SearchInput
                    type="text"
                    placeholder="Rechercher par ville..."
                    value={searchFilters.ville}
                    onChange={(e) => setSearchFilters({...searchFilters, ville: e.target.value})}
                  />
                </SearchField>
                <SearchField>
                  <SearchLabel>Quartier</SearchLabel>
                  <SearchInput
                    type="text"
                    placeholder="Rechercher par quartier..."
                    value={searchFilters.quartier}
                    onChange={(e) => setSearchFilters({...searchFilters, quartier: e.target.value})}
                  />
                </SearchField>
                <SearchField>
                  <SearchLabel>Année</SearchLabel>
                  <YearFilter
                    selectedYear={selectedYearAthletes}
                    onYearChange={setSelectedYearAthletes}
                    availableYears={getAvailableYearsAthletes()}
                    label=""
                  />
                </SearchField>
              </SearchGrid>
              <SearchActions>
                <SearchButton variant="primary" onClick={handleSearch}>
                  <SearchIcon /> Rechercher
                </SearchButton>
                <SearchButton variant="secondary" onClick={handleClearSearch}>
                  <ClearIcon /> Effacer
                </SearchButton>
                <SearchButton variant="print" onClick={handlePrint}>
                  <PrintIcon /> Imprimer
                </SearchButton>
              </SearchActions>
            </SearchContainer>

            {/* Résultats */}
            <DataTable>
              <TableHeader>
                <ResultsHeader>
                  <TableTitle>Athlètes Approuvés</TableTitle>
                  <ResultsCount>
                    {filteredAthletesByYear.length} résultat{filteredAthletesByYear.length > 1 ? 's' : ''} sur {athletes.length} (filtré par année {selectedYearAthletes})
                  </ResultsCount>
                </ResultsHeader>
              </TableHeader>
              <TableContainer>
                {filteredAthletesByYear.length === 0 ? (
                  <EmptyState>
                    <EmptyIcon><SearchIcon /></EmptyIcon>
                    <EmptyTitle>Aucun athlète trouvé pour l'année {selectedYearAthletes}</EmptyTitle>
                    <EmptyText>Essayez de modifier l'année ou vos critères de recherche</EmptyText>
                  </EmptyState>
                ) : (
                  <StyledTable>
                    <TableHead>
                      <tr>
                        <TableHeaderCell>Nom</TableHeaderCell>
                        <TableHeaderCell>Prénom</TableHeaderCell>
                        <TableHeaderCell>Téléphone</TableHeaderCell>
                        <TableHeaderCell>Ville</TableHeaderCell>
                         <TableHeaderCell>Quartier</TableHeaderCell>
                         <TableHeaderCell>Grade</TableHeaderCell>
                        <TableHeaderCell>Date de naissance</TableHeaderCell>
                        <TableHeaderCell>Club</TableHeaderCell>
                        <TableHeaderCell>Montant d'adhésion</TableHeaderCell>
                        <TableHeaderCell>Contact d'urgence</TableHeaderCell>
                        <TableHeaderCell>Date d'inscription</TableHeaderCell>
                        <TableHeaderCell>Statut</TableHeaderCell>
                        <TableHeaderCell>Actions</TableHeaderCell>
                      </tr>
                    </TableHead>
                    <TableBody>
                      {filteredAthletesByYear.map(athlete => (
                        <TableRow key={athlete.id}>
                          <TableCell>
                            <strong>{athlete.nom}</strong>
                          </TableCell>
                          <TableCell>{athlete.prenom}</TableCell>
                          <TableCell>{athlete.telephone}</TableCell>
                          <TableCell>{athlete.situationGeographique}</TableCell>
                           <TableCell>{athlete.quartier}</TableCell>
                           <TableCell>{athlete.grade}</TableCell>
                          <TableCell>{new Date(athlete.dateNaissance).toLocaleDateString('fr-FR')}</TableCell>
                           <TableCell>{athlete.clubSouhaite || 'N/A'}</TableCell>
                           <TableCell>
                             {athlete.montantAdhesion ? `${athlete.montantAdhesion.toLocaleString('fr-FR')} FCFA` : 'Non défini'}
                           </TableCell>
                          <TableCell>
                            {athlete.contactUrgence.prenom} {athlete.contactUrgence.nom}<br/>
                            <small>{athlete.contactUrgence.telephone}</small>
                          </TableCell>
                          <TableCell>{formatDate(athlete.dateCreation)}</TableCell>
                          <TableCell>
                            <StatusBadge status={athlete.statut}>
                              {athlete.statut === 'approuve' ? 'Approuvé' : athlete.statut}
                            </StatusBadge>
                          </TableCell>
                          <TableCell>
                            <ActionButtons>
                              <ActionButton 
                                variant="edit" 
                                onClick={() => handleEditAthlete(athlete)}
                              >
                                <EditIcon /> Modifier
                              </ActionButton>
                              <ActionButton 
                                variant="delete" 
                                onClick={() => handleDeleteAthlete(athlete.id)}
                              >
                                <DeleteIcon /> Supprimer
                              </ActionButton>
                            </ActionButtons>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </StyledTable>
                )}
              </TableContainer>
            </DataTable>


          </>
        )}
        
        {activeTab === 'pending-clubs' && (
          <>
            <PageHeader>
              <PageTitle><PendingIcon /> Clubs en Attente d'Approbation</PageTitle>
              <PageSubtitle>Gérer les demandes d'affiliation de clubs</PageSubtitle>
            </PageHeader>
            
            <DataTable>
              <TableHeader>
                <TableTitle>Clubs en Attente ({pendingClubs.length})</TableTitle>
              </TableHeader>
              <TableContainer>
                {pendingClubs.length === 0 ? (
                  <EmptyState>
                    <EmptyIcon><CheckCircleIcon /></EmptyIcon>
                    <EmptyTitle>Aucun club en attente d'approbation</EmptyTitle>
                    <EmptyText>Tous les clubs ont été traités</EmptyText>
                  </EmptyState>
                ) : (
                  <StyledTable>
                    <TableHead>
                      <tr>
                        <TableHeaderCell>Nom du Club</TableHeaderCell>
                        <TableHeaderCell>Maître</TableHeaderCell>
                        <TableHeaderCell>Grade</TableHeaderCell>
                        <TableHeaderCell>Téléphone</TableHeaderCell>
                        <TableHeaderCell>Localisation</TableHeaderCell>
                        <TableHeaderCell>Date de demande</TableHeaderCell>
                        <TableHeaderCell>Statut</TableHeaderCell>
                        <TableHeaderCell>Actions</TableHeaderCell>
                      </tr>
                    </TableHead>
                    <TableBody>
                      {pendingClubs.map(club => (
                        <TableRow key={club.id}>
                          <TableCell>
                            <strong>{club.nomClub}</strong>
                          </TableCell>
                          <TableCell>{club.prenomMaitre} {club.nomMaitre}</TableCell>
                          <TableCell>{club.grade}</TableCell>
                          <TableCell>{club.telephone}</TableCell>
                          <TableCell>{club.ville}, {club.quartier}</TableCell>
                          <TableCell>{formatDate(club.dateCreation)}</TableCell>
                          <TableCell>
                            <StatusBadge status={club.statut}>
                              En attente
                            </StatusBadge>
                          </TableCell>
                          <TableCell>
                            <ActionButtons>
                              <ActionButton 
                                variant="approve" 
                                onClick={() => handleApproveClub(club)}
                              >
                                <ApproveIcon /> Approuver
                              </ActionButton>
                              <ActionButton 
                                variant="reject" 
                                onClick={() => handleRejectClub(club.id)}
                              >
                                <RejectIcon /> Rejeter
                              </ActionButton>
                            </ActionButtons>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </StyledTable>
                )}
              </TableContainer>
            </DataTable>
          </>
        )}
        
        {activeTab === 'pending-athletes' && (
          <>
            <PageHeader>
              <PageTitle><PendingIcon /> Athlètes en Attente d'Approbation</PageTitle>
              <PageSubtitle>Gérer les demandes d'affiliation d'athlètes</PageSubtitle>
            </PageHeader>
            
            <DataTable>
              <TableHeader>
                <TableTitle>Athlètes en Attente ({pendingAthletes.length})</TableTitle>
              </TableHeader>
              <TableContainer>
                {pendingAthletes.length === 0 ? (
                  <EmptyState>
                    <EmptyIcon><CheckCircleIcon /></EmptyIcon>
                    <EmptyTitle>Aucun athlète en attente d'approbation</EmptyTitle>
                    <EmptyText>Tous les athlètes ont été traités</EmptyText>
                  </EmptyState>
                ) : (
                  <StyledTable>
                    <TableHead>
                      <tr>
                        <TableHeaderCell>Nom</TableHeaderCell>
                        <TableHeaderCell>Prénom</TableHeaderCell>
                        <TableHeaderCell>Téléphone</TableHeaderCell>
                         <TableHeaderCell>Ville</TableHeaderCell>
                         <TableHeaderCell>Quartier</TableHeaderCell>
                         <TableHeaderCell>Grade</TableHeaderCell>
                        <TableHeaderCell>Date de naissance</TableHeaderCell>
                        <TableHeaderCell>Club</TableHeaderCell>
                        <TableHeaderCell>Contact d'urgence</TableHeaderCell>
                        <TableHeaderCell>Date de demande</TableHeaderCell>
                        <TableHeaderCell>Statut</TableHeaderCell>
                        <TableHeaderCell>Actions</TableHeaderCell>
                      </tr>
                    </TableHead>
                    <TableBody>
                      {pendingAthletes.map(athlete => (
                        <TableRow key={athlete.id}>
                          <TableCell>
                            <strong>{athlete.nom}</strong>
                          </TableCell>
                          <TableCell>{athlete.prenom}</TableCell>
                          <TableCell>{athlete.telephone}</TableCell>
                          <TableCell>{athlete.situationGeographique}</TableCell>
                           <TableCell>{athlete.quartier}</TableCell>
                           <TableCell>{athlete.grade}</TableCell>
                          <TableCell>{new Date(athlete.dateNaissance).toLocaleDateString('fr-FR')}</TableCell>
                           <TableCell>{athlete.clubSouhaite || 'N/A'}</TableCell>
                          <TableCell>
                            {athlete.contactUrgence.prenom} {athlete.contactUrgence.nom}<br/>
                            <small>{athlete.contactUrgence.telephone}</small>
                          </TableCell>
                          <TableCell>{formatDate(athlete.dateCreation)}</TableCell>
                          <TableCell>
                            <StatusBadge status={athlete.statut}>
                              En attente
                            </StatusBadge>
                          </TableCell>
                          <TableCell>
                            <ActionButtons>
                              <ActionButton 
                                variant="approve" 
                                onClick={() => handleApproveAthlete(athlete)}
                              >
                                <ApproveIcon /> Approuver
                              </ActionButton>
                              <ActionButton 
                                variant="reject" 
                                onClick={() => handleRejectAthlete(athlete.id)}
                              >
                                <RejectIcon /> Rejeter
                              </ActionButton>
                            </ActionButtons>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </StyledTable>
                )}
              </TableContainer>
            </DataTable>
          </>
        )}
        
        {activeTab === 'finance' && (
          <>
            <PageHeader>
              <PageTitle><FinanceIcon /> Finance et Comptabilité</PageTitle>
              <PageSubtitle>Analyse des revenus générés par les adhésions</PageSubtitle>
            </PageHeader>
            
            {/* Section de recherche de club */}
            <SearchContainer>
              <SearchGrid>
                <SearchField>
                  <SearchLabel>Rechercher un club</SearchLabel>
                  <SearchInput
                    type="text"
                    placeholder="Entrez le nom du club pour voir ses informations financières..."
                    value={searchFilters.nom}
                    onChange={(e) => setSearchFilters({...searchFilters, nom: e.target.value})}
                  />
                </SearchField>
                <SearchField>
                  <SearchLabel>Année</SearchLabel>
                  <YearFilter
                    selectedYear={selectedYearFinance}
                    onYearChange={setSelectedYearFinance}
                    availableYears={getAvailableYearsFinance()}
                    label=""
                  />
                </SearchField>
              </SearchGrid>
              <SearchActions>
                <SearchButton variant="primary" onClick={() => {
                  const term = (searchFilters.nom || '').trim().toLowerCase();

                  const filteredByYear = clubs
                    .filter((club: any) => isApprovedWithMontant(club))
                    .filter((club: any) => !term || (club.nomClub || '').toLowerCase().includes(term))
                    .filter((club: any) => {
                      const d = getFinanceDate(club);
                      return !!d && d.getFullYear() === selectedYearFinance;
                    });
                  setFilteredClubsByYear(filteredByYear);

                  const athletesFilteredByYear = athletes
                    .filter((athlete: any) => isApprovedWithMontant(athlete))
                    .filter((athlete: any) => {
                      const d = getFinanceDate(athlete);
                      return !!d && d.getFullYear() === selectedYearFinance;
                    });
                  setFilteredAthletesByYear(athletesFilteredByYear);
                }}>
                  <SearchIcon /> Rechercher
                </SearchButton>
                <SearchButton variant="secondary" onClick={() => {
                  setSearchFilters({ nom: '', prenom: '', ville: '', quartier: '' });
                  // Réappliquer le filtre par année
                  filterFinanceClubsByYear(selectedYearFinance);
                  filterFinanceAthletesByYear(selectedYearFinance);
                }}>
                  <ClearIcon /> Effacer
                </SearchButton>
              </SearchActions>
            </SearchContainer>
            
            {(filteredClubsByYear.length === 0 && filteredAthletesByYear.length === 0) ? (
              <EmptyState>
                <EmptyIcon><SearchIcon /></EmptyIcon>
                <EmptyTitle>Aucune approbation trouvée pour l'année {selectedYearFinance}</EmptyTitle>
                <EmptyText>Si aucun club/athlète n'a été approuvé cette année, aucun montant n'est affiché.</EmptyText>
              </EmptyState>
            ) : (
              <>
                {/* Statistiques financières globales */}
                <StatsGrid>
                  <StatCard>
                    <StatNumber>
                      {filteredClubsByYear.reduce((total, club) => total + (club.montantAdhesion || 0), 0).toLocaleString('fr-FR')} FCFA
                    </StatNumber>
                    <StatLabel>Revenus totaux des clubs ({selectedYearFinance})</StatLabel>
                  </StatCard>
                  <StatCard>
                    <StatNumber>
                      {filteredAthletesByYear.reduce((total, athlete) => total + (athlete.montantAdhesion || 0), 0).toLocaleString('fr-FR')} FCFA
                    </StatNumber>
                    <StatLabel>Revenus totaux des athlètes ({selectedYearFinance})</StatLabel>
                  </StatCard>
                  <StatCard>
                    <StatNumber>
                      {(filteredClubsByYear.reduce((total, club) => total + (club.montantAdhesion || 0), 0) +
                        filteredAthletesByYear.reduce((total, athlete) => total + (athlete.montantAdhesion || 0), 0)).toLocaleString('fr-FR')} FCFA
                    </StatNumber>
                    <StatLabel>Revenus totaux ({selectedYearFinance})</StatLabel>
                  </StatCard>
                  <StatCard>
                    <StatNumber>{filteredClubsByYear.length}</StatNumber>
                    <StatLabel>Clubs avec adhésion ({selectedYearFinance})</StatLabel>
                  </StatCard>
                </StatsGrid>

                {/* Analyse par période */}
                <div style={{ marginBottom: '30px' }}>
                  <h3 style={{ marginBottom: '20px', color: '#333' }}>Analyse par période</h3>
                  
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '20px' }}>
                    <div style={{ background: 'white', padding: '20px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                      <h4 style={{ marginBottom: '15px', color: '#666', fontSize: '1.1rem' }}>Ce mois</h4>
                      <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#666' }}>
                        {(() => {
                          const now = new Date();
                          const thisMonth = now.getMonth();
                          const thisYear = now.getFullYear();
                          
                          const thisMonthAthletes = filteredAthletesByYear.filter(a => {
                            const d = getFinanceDate(a) || new Date(a.dateCreation);
                            return !isNaN(d.getTime()) && d.getMonth() === thisMonth && d.getFullYear() === thisYear;
                          });
                          
                          const monthRevenue = thisMonthAthletes.reduce((total, athlete) => total + (athlete.montantAdhesion || 0), 0);
                          
                          return monthRevenue.toLocaleString('fr-FR') + ' FCFA';
                        })()}
                      </div>
                    </div>
                    
                    <div style={{ background: 'white', padding: '20px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                      <h4 style={{ marginBottom: '15px', color: '#666', fontSize: '1.1rem' }}>2 derniers mois</h4>
                      <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#666' }}>
                        {(() => {
                          const now = new Date();
                          const twoMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 2, 1);
                          const twoMonthsRevenue = filteredAthletesByYear
                            .filter(a => {
                              const d = getFinanceDate(a) || new Date(a.dateCreation);
                              return !isNaN(d.getTime()) && d >= twoMonthsAgo;
                            })
                            .reduce((total, athlete) => total + (athlete.montantAdhesion || 0), 0);
                          return twoMonthsRevenue.toLocaleString('fr-FR') + ' FCFA';
                        })()}
                      </div>
                    </div>
                    
                    <div style={{ background: 'white', padding: '20px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                      <h4 style={{ marginBottom: '15px', color: '#666', fontSize: '1.1rem' }}>6 derniers mois</h4>
                      <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#666' }}>
                        {(() => {
                          const now = new Date();
                          const sixMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 6, 1);
                          const sixMonthsRevenue = filteredAthletesByYear
                            .filter(a => {
                              const d = getFinanceDate(a) || new Date(a.dateCreation);
                              return !isNaN(d.getTime()) && d >= sixMonthsAgo;
                            })
                            .reduce((total, athlete) => total + (athlete.montantAdhesion || 0), 0);
                          return sixMonthsRevenue.toLocaleString('fr-FR') + ' FCFA';
                        })()}
                      </div>
                    </div>
                    
                    <div style={{ background: 'white', padding: '20px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
                      <h4 style={{ marginBottom: '15px', color: '#666', fontSize: '1.1rem' }}>Cette année</h4>
                      <div style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#666' }}>
                        {(() => {
                          const yearRevenue = filteredAthletesByYear.reduce((total, athlete) => total + (athlete.montantAdhesion || 0), 0);
                          return yearRevenue.toLocaleString('fr-FR') + ' FCFA';
                        })()}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {(filteredClubsByYear.length === 0 && filteredAthletesByYear.length === 0) ? null : (filteredClubsByYear.length === 0 ? (
              <EmptyState>
                <EmptyIcon><SearchIcon /></EmptyIcon>
                <EmptyTitle>Aucun club approuvé trouvé pour l'année {selectedYearFinance}</EmptyTitle>
                <EmptyText>Les montants des athlètes peuvent exister, mais aucun club n'a été approuvé cette année.</EmptyText>
              </EmptyState>
            ) : (
              <>
                {/* Tableau des revenus par club */}
                <DataTable>
                  <TableHeader>
                    <TableTitle>
                      Revenus par Club 
                      {searchFilters.nom && (
                        <span style={{ fontSize: '0.9rem', color: '#666', fontWeight: 'normal' }}>
                          {' '}- Recherche: "{searchFilters.nom}" ({filteredClubsByYear.length} résultat{filteredClubsByYear.length > 1 ? 's' : ''})
                        </span>
                      )}
                    </TableTitle>
                  </TableHeader>
                  <TableContainer>
                    <StyledTable>
                      <TableHead>
                        <tr>
                          <TableHeaderCell>Nom du Club</TableHeaderCell>
                          <TableHeaderCell>Maître</TableHeaderCell>
                          <TableHeaderCell>Ville</TableHeaderCell>
                          <TableHeaderCell>Montant d'adhésion club</TableHeaderCell>
                          <TableHeaderCell>Nombre d'athlètes</TableHeaderCell>
                          <TableHeaderCell>Revenus des athlètes</TableHeaderCell>
                          <TableHeaderCell>Revenus totaux</TableHeaderCell>
                        </tr>
                      </TableHead>
                      <TableBody>
                        {filteredClubsByYear.map(club => {
                        const clubAthletes = filteredAthletesByYear.filter(a => a.clubSouhaite === club.nomClub);
                        const athletesWithRevenue = clubAthletes.filter(a => a.montantAdhesion && a.montantAdhesion > 0);
                        const athletesRevenue = athletesWithRevenue.reduce((total, athlete) => total + (athlete.montantAdhesion || 0), 0);
                        const totalRevenue = (club.montantAdhesion || 0) + athletesRevenue;
                        
                        return (
                          <TableRow key={club.id}>
                            <TableCell>
                              <strong>{club.nomClub}</strong>
                            </TableCell>
                            <TableCell>{club.prenomMaitre} {club.nomMaitre}</TableCell>
                            <TableCell>{club.ville}, {club.quartier}</TableCell>
                            <TableCell>
                              {(club.montantAdhesion || 0).toLocaleString('fr-FR')} FCFA
                            </TableCell>
                            <TableCell>{athletesWithRevenue.length}</TableCell>
                            <TableCell>
                              {athletesRevenue.toLocaleString('fr-FR')} FCFA
                            </TableCell>
                            <TableCell>
                              <strong style={{ color: '#666' }}>
                                {totalRevenue.toLocaleString('fr-FR')} FCFA
                              </strong>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                      </TableBody>
                    </StyledTable>
                  </TableContainer>
                </DataTable>

                {/* Tableau des revenus par période pour chaque club */}
                <DataTable style={{ marginTop: '30px' }}>
                  <TableHeader>
                    <TableTitle>
                      Analyse détaillée par période et par club
                      {searchFilters.nom && (
                        <span style={{ fontSize: '0.9rem', color: '#666', fontWeight: 'normal' }}>
                          {' '}- Recherche: "{searchFilters.nom}" ({filteredClubsByYear.length} résultat{filteredClubsByYear.length > 1 ? 's' : ''})
                        </span>
                      )}
                    </TableTitle>
                  </TableHeader>
                  <TableContainer>
                    <StyledTable>
                      <TableHead>
                        <tr>
                          <TableHeaderCell>Nom du Club</TableHeaderCell>
                          <TableHeaderCell>Ce mois</TableHeaderCell>
                          <TableHeaderCell>2 derniers mois</TableHeaderCell>
                          <TableHeaderCell>6 derniers mois</TableHeaderCell>
                          <TableHeaderCell>Cette année</TableHeaderCell>
                          <TableHeaderCell>Total</TableHeaderCell>
                        </tr>
                      </TableHead>
                      <TableBody>
                        {filteredClubsByYear.map(club => {
                        const clubAthletes = filteredAthletesByYear.filter(a => a.clubSouhaite === club.nomClub);
                        const now = new Date();
                        
                        // Ce mois
                        const thisMonth = now.getMonth();
                        const thisYear = now.getFullYear();
                        
                        const thisMonthRevenue = clubAthletes
                          .filter(a => a.montantAdhesion && a.montantAdhesion > 0)
                          .filter(a => {
                            const date = new Date(a.dateCreation);
                            return date.getMonth() === thisMonth && date.getFullYear() === thisYear;
                          })
                          .reduce((total, athlete) => total + (athlete.montantAdhesion || 0), 0);
                        
                        // 2 derniers mois
                        const twoMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 2, 1);
                        const twoMonthsRevenue = clubAthletes
                          .filter(a => a.montantAdhesion && a.montantAdhesion > 0)
                          .filter(a => new Date(a.dateCreation) >= twoMonthsAgo)
                          .reduce((total, athlete) => total + (athlete.montantAdhesion || 0), 0);
                        
                        // 6 derniers mois
                        const sixMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 6, 1);
                        const sixMonthsRevenue = clubAthletes
                          .filter(a => a.montantAdhesion && a.montantAdhesion > 0)
                          .filter(a => new Date(a.dateCreation) >= sixMonthsAgo)
                          .reduce((total, athlete) => total + (athlete.montantAdhesion || 0), 0);
                        
                        // Cette année
                        const yearRevenue = clubAthletes
                          .filter(a => a.montantAdhesion && a.montantAdhesion > 0)
                          .filter(a => new Date(a.dateCreation).getFullYear() === thisYear)
                          .reduce((total, athlete) => total + (athlete.montantAdhesion || 0), 0);
                        
                        // Total
                        const totalRevenue = (club.montantAdhesion || 0) + clubAthletes.filter(a => a.montantAdhesion && a.montantAdhesion > 0).reduce((total, athlete) => total + (athlete.montantAdhesion || 0), 0);
                        
                        return (
                          <TableRow key={club.id}>
                            <TableCell>
                              <strong>{club.nomClub}</strong>
                            </TableCell>
                            <TableCell>
                              {thisMonthRevenue.toLocaleString('fr-FR')} FCFA
                            </TableCell>
                            <TableCell>
                              {twoMonthsRevenue.toLocaleString('fr-FR')} FCFA
                            </TableCell>
                            <TableCell>
                              {sixMonthsRevenue.toLocaleString('fr-FR')} FCFA
                            </TableCell>
                            <TableCell>
                              {yearRevenue.toLocaleString('fr-FR')} FCFA
                            </TableCell>
                            <TableCell>
                              <strong style={{ color: '#666' }}>
                                {totalRevenue.toLocaleString('fr-FR')} FCFA
                              </strong>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                      </TableBody>
                    </StyledTable>
                  </TableContainer>
                </DataTable>
              </>
            ))}
          </>
        )}
        
        {activeTab === 'gestions' && (
          <>
            <PageHeader>
              <PageTitle><SettingsIcon /> Gestion</PageTitle>
              <PageSubtitle>Gérer les différentes fonctionnalités de gestion</PageSubtitle>
            </PageHeader>
            
            {gestionView === 'main' && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
                {/* Carte Gestion des vidéos */}
                <div 
                  onClick={() => setGestionView('videos')}
                  style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    padding: '30px',
                    borderRadius: '20px',
                    cursor: 'pointer',
                    color: 'white',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(102, 126, 234, 0.3)',
                    transition: 'all 0.3s ease',
                    minHeight: '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 15px 40px rgba(102, 126, 234, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(102, 126, 234, 0.3)';
                  }}
                >
                  <div style={{ position: 'absolute', top: '20px', right: '20px', fontSize: '3rem', opacity: '0.3' }}>
                    🎬
                  </div>
                  <div>
                    <h3 style={{ margin: '0 0 10px 0', fontSize: '1.5rem', fontWeight: '600' }}>
                      Gestion des Vidéos
                    </h3>
                    <p style={{ margin: '0 0 20px 0', opacity: '0.9', fontSize: '1rem' }}>
                      Gérez votre bibliothèque vidéo avec des fonctionnalités avancées
                    </p>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ fontSize: '0.9rem', opacity: '0.8' }}>
                        {videos.length} vidéos disponibles
                      </span>
                    </div>
                  </div>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '10px',
                    fontSize: '0.9rem',
                    opacity: '0.8'
                  }}>
                    <span>Cliquer pour gérer</span>
                    <span>→</span>
                  </div>
                </div>

                {/* Carte Gestion des photos */}
                <div 
                  onClick={() => setGestionView('photos')}
                  style={{
                    background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                    padding: '30px',
                    borderRadius: '20px',
                    cursor: 'pointer',
                    color: 'white',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(240, 147, 251, 0.3)',
                    transition: 'all 0.3s ease',
                    minHeight: '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 15px 40px rgba(240, 147, 251, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(240, 147, 251, 0.3)';
                  }}
                >
                  <div style={{ position: 'absolute', top: '20px', right: '20px', fontSize: '3rem', opacity: '0.3' }}>
                    📸
                  </div>
                  <div>
                    <h3 style={{ margin: '0 0 10px 0', fontSize: '1.5rem', fontWeight: '600' }}>
                      Gestion des Photos
                    </h3>
                    <p style={{ margin: '0 0 20px 0', opacity: '0.9', fontSize: '1rem' }}>
                      Organisez votre collection de photos avec facilité
                    </p>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ fontSize: '0.9rem', opacity: '0.8' }}>
                        {photos.length} photos disponibles
                      </span>
                    </div>
                  </div>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '10px',
                    fontSize: '0.9rem',
                    opacity: '0.8'
                  }}>
                    <span>Cliquer pour gérer</span>
                    <span>→</span>
                  </div>
                </div>

                {/* Carte Gestion des calendriers */}
                <div 
                  onClick={() => setGestionView('calendrier')}
                  style={{
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    padding: '30px',
                    borderRadius: '20px',
                    cursor: 'pointer',
                    color: 'white',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(16, 185, 129, 0.3)',
                    transition: 'all 0.3s ease',
                    minHeight: '200px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 15px 40px rgba(16, 185, 129, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(16, 185, 129, 0.3)';
                  }}
                >
                  <div style={{ position: 'absolute', top: '20px', right: '20px', fontSize: '3rem', opacity: '0.3' }}>
                    📅
                  </div>
                  <div>
                    <h3 style={{ margin: '0 0 10px 0', fontSize: '1.5rem', fontWeight: '600' }}>
                      Gestion des Calendriers
                    </h3>
                    <p style={{ margin: '0 0 20px 0', opacity: '0.9', fontSize: '1rem' }}>
                      Planifiez et gérez les événements du club
                    </p>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ fontSize: '0.9rem', opacity: '0.8' }}>
                        {evenements.length} événements planifiés
                      </span>
                    </div>
                  </div>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '10px',
                    fontSize: '0.9rem',
                    opacity: '0.8'
                  }}>
                    <span>Cliquer pour gérer</span>
                    <span>→</span>
                  </div>
                </div>
              </div>
            )}

            {/* Vue de gestion des vidéos */}
            {gestionView === 'videos' && (
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '30px' }}>
                  <button 
                    onClick={() => setGestionView('main')}
                    style={{ 
                      background: 'none', 
                      border: 'none', 
                      fontSize: '1.5rem', 
                      cursor: 'pointer', 
                      color: '#666',
                      padding: '5px'
                    }}
                  >
                    ←
                  </button>
                  <div>
                    <h2 style={{ margin: '0 0 5px 0', color: '#333' }}>Gestion des Vidéos</h2>
                    <p style={{ margin: 0, color: '#666' }}>Gérer la bibliothèque vidéo du club</p>
                  </div>
                </div>

                {/* Zone d'upload simple */}
                <div style={{ 
                  background: 'white', 
                  padding: '30px', 
                  borderRadius: '15px', 
                  boxShadow: '0 4px 15px rgba(0,0,0,0.1)', 
                  marginBottom: '30px',
                  textAlign: 'center'
                }}>
                  <div style={{
                    border: '3px dashed #667eea',
                    borderRadius: '15px',
                    padding: '40px',
                    background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#764ba2';
                    e.currentTarget.style.background = 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = '#667eea';
                    e.currentTarget.style.background = 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)';
                  }}
                  onClick={() => document.getElementById('simple-video-upload')?.click()}>
                    <input
                      id="simple-video-upload"
                      type="file"
                      accept="video/*"
                      onChange={(e) => handleSimpleVideoUpload(e)}
                      style={{ display: 'none' }}
                    />
                    <div style={{ fontSize: '4rem', marginBottom: '20px' }}>🎬</div>
                    <h3 style={{ margin: '0 0 10px 0', color: '#333', fontSize: '1.5rem' }}>
                      Cliquer ici pour ajouter une video
                    </h3>
                    <p style={{ margin: '0 0 20px 0', color: '#666' }}>
                      Formats acceptés: MP4, AVI, MOV (max 1 Go)
                    </p>
                    <div style={{
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white',
                      padding: '12px 24px',
                      borderRadius: '25px',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '10px',
                      fontWeight: '600',
                      fontSize: '1rem',
                      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
                    }}>
                      <UploadIcon /> Choisir un fichier vidéo
                    </div>
                  </div>
                </div>

                <div style={{ background: 'white', padding: '20px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                      <h3 style={{ margin: 0, color: '#333' }}>Vidéos ({videos.length})</h3>
                      <YearFilter
                        selectedYear={selectedYearVideos}
                        onYearChange={setSelectedYearVideos}
                        availableYears={getAvailableYearsVideos()}
                        label="Filtrer par année :"
                      />
                    </div>
                  </div>

                  {!videosLoaded ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                      <div style={{ fontSize: '3rem', marginBottom: '20px' }}>⏳</div>
                      <h4 style={{ margin: '0 0 10px 0', color: '#333' }}>Chargement...</h4>
                      <p style={{ margin: 0 }}>Veuillez patienter pendant le chargement des vidéos</p>
                    </div>
                  ) : filteredVideosByYear.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                      <div style={{ fontSize: '3rem', marginBottom: '20px' }}>📹</div>
                      <h4 style={{ margin: '0 0 10px 0', color: '#333' }}>Aucune vidéo pour l'année {selectedYearVideos}</h4>
                      <p style={{ margin: 0 }}>Essayez de modifier l'année ou ajoutez votre première vidéo</p>
                    </div>
                  ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
                      {filteredVideosByYear.map((video, index) => (
                        <div key={index} style={{ 
                          border: '1px solid #e0e0e0', 
                          borderRadius: '12px', 
                          overflow: 'hidden',
                          background: 'white'
                        }}>
                          <div style={{ 
                            height: '200px', 
                            position: 'relative',
                            backgroundColor: '#f0f0f0',
                            overflow: 'hidden'
                          }}>
                            {/* Lecteur vidéo */}
                            <video
                              src={video.url}
                              poster={video.thumbnail}
                              controls
                              preload="metadata"
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                              }}
                              onError={(e) => {
                                console.error('Erreur de lecture vidéo:', e);
                                // En cas d'erreur, afficher le thumbnail comme fallback
                                const target = e.target as HTMLVideoElement;
                                target.style.display = 'none';
                                const fallback = target.parentElement?.querySelector('.video-fallback') as HTMLElement;
                                if (fallback) fallback.style.display = 'block';
                              }}
                            >
                              Votre navigateur ne supporte pas la lecture de vidéos.
                            </video>
                            
                            {/* Fallback thumbnail en cas d'erreur de lecture */}
                            <div 
                              className="video-fallback"
                              style={{ 
                                display: 'none',
                                height: '100%', 
                                backgroundImage: `url(${video.thumbnail})`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0
                              }}
                            >
                              <div style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: 'rgba(0,0,0,0.7)',
                                color: 'white',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                fontSize: '0.8rem'
                              }}>
                                {video.duration || '00:00'}
                              </div>
                              {!video.thumbnail && (
                                <div style={{
                                  position: 'absolute',
                                  top: '50%',
                                  left: '50%',
                                  transform: 'translate(-50%, -50%)',
                                  color: '#666',
                                  fontSize: '2rem'
                                }}>
                                  🎬
                                </div>
                              )}
                              {/* Indicateur que c'est une vidéo */}
                              <div style={{
                                position: 'absolute',
                                bottom: '10px',
                                left: '10px',
                                background: 'rgba(0,0,0,0.7)',
                                color: 'white',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                fontSize: '0.8rem'
                              }}>
                                🎬 Vidéo
                              </div>
                            </div>
                          </div>
                          <div style={{ padding: '15px' }}>
                            <h4 style={{ margin: '0 0 10px 0', color: '#333', fontSize: '1.1rem' }}>
                              {video.title}
                            </h4>
                            <p style={{ 
                              margin: '0 0 15px 0', 
                              color: '#666', 
                              fontSize: '0.9rem',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden'
                            }}>
                              {video.description}
                            </p>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <span style={{ 
                                background: '#f0f0f0', 
                                padding: '4px 8px', 
                                borderRadius: '12px', 
                                fontSize: '0.8rem',
                                color: '#666'
                              }}>
                                {video.category}
                              </span>
                              <div style={{ display: 'flex', gap: '8px' }}>
                                <button 
                                  onClick={() => {
                                    setEditingMedia(video);
                                    setMediaForm({
                                      title: video.title,
                                      description: video.description,
                                      url: video.url,
                                      thumbnail: video.thumbnail || '',
                                      duration: video.duration || '',
                                      category: video.category
                                    });
                                    setShowMediaModal(true);
                                  }}
                                  style={{
                                    background: '#2196F3',
                                    color: 'white',
                                    border: 'none',
                                    padding: '6px 12px',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontSize: '0.8rem'
                                  }}
                                >
                                  <EditIcon /> Modifier
                                </button>
                                                                  <button 
                                   onClick={async () => {
                                     if (window.confirm('Êtes-vous sûr de vouloir supprimer cette vidéo ?')) {
                                       try {
                                         await videoService.deleteVideo(video.id);
                                         setVideos(prevVideos => prevVideos.filter(v => v.id !== video.id));
                                         setMessage({ type: 'success', text: 'Vidéo supprimée avec succès' });
                                       } catch (error) {
                                         console.error('Erreur lors de la suppression:', error);
                                         setMessage({ 
                                           type: 'error', 
                                           text: 'Erreur lors de la suppression de la vidéo' 
                                         });
                                       }
                                     }
                                   }}
                                  style={{
                                    background: '#f44336',
                                    color: 'white',
                                    border: 'none',
                                    padding: '6px 12px',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontSize: '0.8rem'
                                  }}
                                >
                                  <DeleteIcon /> Supprimer
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Vue de gestion des photos */}
            {gestionView === 'photos' && (
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '30px' }}>
                  <button 
                    onClick={() => setGestionView('main')}
                    style={{ 
                      background: 'none', 
                      border: 'none', 
                      fontSize: '1.5rem', 
                      cursor: 'pointer', 
                      color: '#666',
                      padding: '5px'
                    }}
                  >
                    ←
                  </button>
                  <div>
                    <h2 style={{ margin: '0 0 5px 0', color: '#333' }}>Gestion des Photos</h2>
                    <p style={{ margin: 0, color: '#666' }}>Gérer la galerie photos du club</p>
                  </div>
                </div>

                <div style={{ background: 'white', padding: '20px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                      <h3 style={{ margin: 0, color: '#333' }}>Photos ({photos.length})</h3>
                      <YearFilter
                        selectedYear={selectedYearPhotos}
                        onYearChange={setSelectedYearPhotos}
                        availableYears={getAvailableYearsPhotos()}
                        label="Filtrer par année :"
                      />
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <button 
                        onClick={() => {
                          const input = document.createElement('input');
                          input.type = 'file';
                          input.accept = 'image/*';
                          input.onchange = (e) => {
                            const file = (e.target as HTMLInputElement).files?.[0];
                            if (file) {
                              handleImageSelect(file);
                            }
                          };
                          input.click();
                        }}
                        style={{
                          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                          color: 'white',
                          border: 'none',
                          padding: '12px 24px',
                          borderRadius: '12px',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          fontWeight: '600',
                          fontSize: '1rem',
                          boxShadow: '0 4px 15px rgba(240, 147, 251, 0.3)',
                          transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 6px 20px rgba(240, 147, 251, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 4px 15px rgba(240, 147, 251, 0.3)';
                        }}
                      >
                        📸 Cliquer ici pour ajouter une image
                      </button>
                    </div>
                  </div>

                  {filteredPhotosByYear.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                      <div style={{ fontSize: '3rem', marginBottom: '20px' }}>📸</div>
                      <h4 style={{ margin: '0 0 10px 0', color: '#333' }}>Aucune photo pour l'année {selectedYearPhotos}</h4>
                      <p style={{ margin: 0 }}>Essayez de modifier l'année ou ajoutez votre première photo</p>
                    </div>
                  ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '20px' }}>
                      {filteredPhotosByYear.map((photo, index) => (
                        <div key={index} style={{ 
                          border: '1px solid #e0e0e0', 
                          borderRadius: '12px', 
                          overflow: 'hidden',
                          background: 'white'
                        }}>
                          <div style={{ 
                            height: '200px', 
                            background: `url(${buildImageUrl(photo.url)}) center/cover`,
                            position: 'relative'
                          }} />
                          <div style={{ padding: '15px' }}>
                            <h4 style={{ margin: '0 0 10px 0', color: '#333', fontSize: '1.1rem' }}>
                              {photo.title}
                            </h4>
                            <p style={{ 
                              margin: '0 0 15px 0', 
                              color: '#666', 
                              fontSize: '0.9rem',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden'
                            }}>
                              {photo.description}
                            </p>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <span style={{ 
                                background: '#f0f0f0', 
                                padding: '4px 8px', 
                                borderRadius: '12px', 
                                fontSize: '0.8rem',
                                color: '#666'
                              }}>
                                {photo.category}
                              </span>
                              <div style={{ display: 'flex', gap: '8px' }}>
                                <button 
                                  onClick={() => {
                                    setEditingMedia(photo);
                                    setMediaForm({
                                      title: photo.title,
                                      description: photo.description,
                                      url: photo.url,
                                      thumbnail: photo.thumbnail || '',
                                      duration: photo.duration || '',
                                      category: photo.category
                                    });
                                    setShowMediaModal(true);
                                  }}
                                  style={{
                                    background: '#2196F3',
                                    color: 'white',
                                    border: 'none',
                                    padding: '6px 12px',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontSize: '0.8rem'
                                  }}
                                >
                                  <EditIcon /> Modifier
                                </button>
                                <button 
                                  onClick={() => handleDeletePhoto(photo.id)}
                                  style={{
                                    background: '#f44336',
                                    color: 'white',
                                    border: 'none',
                                    padding: '6px 12px',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontSize: '0.8rem'
                                  }}
                                >
                                  <DeleteIcon /> Supprimer
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Vue de gestion de la galerie (vidéos + photos) */}
            {gestionView === 'galerie' && (
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '30px' }}>
                  <button 
                    onClick={() => setGestionView('main')}
                    style={{
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '50%',
                      width: '40px',
                      height: '40px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      fontSize: '1.2rem',
                      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'scale(1.1)';
                      e.currentTarget.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.6)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.4)';
                    }}
                  >
                    ←
                  </button>
                  <div>
                    <h2 style={{ margin: '0 0 5px 0', color: '#333' }}>Gestion de la Galerie</h2>
                    <p style={{ margin: 0, color: '#666' }}>Choisissez le type de média à gérer</p>
                  </div>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
                  {/* Option Photos */}
                  <div 
                    onClick={() => setGestionView('photos')}
                    style={{
                      background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                      padding: '40px',
                      borderRadius: '20px',
                      cursor: 'pointer',
                      textAlign: 'center',
                      color: 'white',
                      boxShadow: '0 8px 25px rgba(240, 147, 251, 0.3)',
                      transition: 'all 0.3s ease',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 12px 35px rgba(240, 147, 251, 0.4)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(240, 147, 251, 0.3)';
                    }}
                  >
                    <div style={{ fontSize: '4rem', marginBottom: '20px' }}>📸</div>
                    <h3 style={{ margin: '0 0 10px 0', fontSize: '1.8rem' }}>Photos</h3>
                    <p style={{ margin: '0 0 20px 0', opacity: 0.9 }}>Gérer les photos du club</p>
                    <div style={{ 
                      background: 'rgba(255,255,255,0.2)', 
                      padding: '10px 20px', 
                      borderRadius: '25px',
                      display: 'inline-block',
                      fontSize: '0.9rem'
                    }}>
                      {photos.length} photo{photos.length > 1 ? 's' : ''}
                    </div>
                    <div style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: 'rgba(255,255,255,0.2)',
                      borderRadius: '50%',
                      width: '30px',
                      height: '30px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.2rem'
                    }}>
                      →
                    </div>
                  </div>

                  {/* Option Vidéos */}
                  <div 
                    onClick={() => setGestionView('videos')}
                    style={{
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      padding: '40px',
                      borderRadius: '20px',
                      cursor: 'pointer',
                      textAlign: 'center',
                      color: 'white',
                      boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)',
                      transition: 'all 0.3s ease',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)';
                      e.currentTarget.style.boxShadow = '0 12px 35px rgba(102, 126, 234, 0.4)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 8px 25px rgba(102, 126, 234, 0.3)';
                    }}
                  >
                    <div style={{ fontSize: '4rem', marginBottom: '20px' }}>🎬</div>
                    <h3 style={{ margin: '0 0 10px 0', fontSize: '1.8rem' }}>Vidéos</h3>
                    <p style={{ margin: '0 0 20px 0', opacity: 0.9 }}>Gérer les vidéos du club</p>
                    <div style={{ 
                      background: 'rgba(255,255,255,0.2)', 
                      padding: '10px 20px', 
                      borderRadius: '25px',
                      display: 'inline-block',
                      fontSize: '0.9rem'
                    }}>
                      {videos.length} vidéo{videos.length > 1 ? 's' : ''}
                    </div>
                    <div style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      background: 'rgba(255,255,255,0.2)',
                      borderRadius: '50%',
                      width: '30px',
                      height: '30px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.2rem'
                    }}>
                      →
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Vue de gestion du calendrier des événements */}
            {gestionView === 'calendrier' && (
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '30px' }}>
                  <button 
                    onClick={() => setGestionView('main')}
                    style={{ 
                      background: 'none', 
                      border: 'none', 
                      fontSize: '1.5rem', 
                      cursor: 'pointer', 
                      color: '#666',
                      padding: '5px'
                    }}
                  >
                    ←
                  </button>
                  <div>
                    <h2 style={{ margin: '0 0 5px 0', color: '#333' }}>Calendrier des événements</h2>
                    <p style={{ margin: 0, color: '#666' }}>Gérer les événements à venir du club</p>
                  </div>
                </div>

                <div style={{ background: 'white', padding: '20px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                      <h3 style={{ margin: 0, color: '#333' }}>Événements à venir ({filteredEvenements.length})</h3>
                      
                      {/* Sélecteur d'année */}
                      <YearFilter
                        selectedYear={selectedYear}
                        onYearChange={setSelectedYear}
                        availableYears={getAvailableYears()}
                        label="Filtrer par année :"
                      />
                    </div>
                    <button 
                      onClick={() => {
                        setEditingEvent(null);
                        setEventForm({
                          titre: '',
                          description: '',
                          dateDebut: '',
                          heureDebut: '',
                          dateFin: '',
                          heureFin: '',
                          lieu: '',
                          type: 'competition'
                        });
                        setShowEventModal(true);
                      }}
                      style={{
                        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                        color: 'white',
                        border: 'none',
                        padding: '12px 24px',
                        borderRadius: '12px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        fontWeight: '600',
                        fontSize: '1rem',
                        boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.3)';
                      }}
                    >
                      <AddIcon /> Ajouter un événement
                    </button>
                  </div>

                  {evenements.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                      <div style={{ fontSize: '3rem', marginBottom: '20px' }}>📅</div>
                      <h4 style={{ margin: '0 0 10px 0', color: '#333' }}>Aucun événement</h4>
                      <p style={{ margin: 0 }}>Commencez par ajouter votre premier événement</p>
                    </div>
                  ) : (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
                      {filteredEvenements.map((event) => (
                        <div key={event.id} style={{ 
                          border: '1px solid #e0e0e0', 
                          borderRadius: '12px', 
                          overflow: 'hidden',
                          background: 'white',
                          position: 'relative'
                        }}>
                          <div style={{ 
                            padding: '20px',
                            background: event.type === 'competition' ? 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)' :
                                       event.type === 'stage' ? 'linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)' :
                                       'linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%)'
                          }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
                              <h4 style={{ margin: 0, color: '#333', fontSize: '1.2rem', fontWeight: '600' }}>
                                {event.titre}
                              </h4>
                              <span style={{
                                padding: '6px 12px',
                                borderRadius: '20px',
                                fontSize: '0.8rem',
                                fontWeight: '600',
                                background: 'rgba(255,255,255,0.8)',
                                color: event.type === 'competition' ? '#92400e' : 
                                       event.type === 'stage' ? '#1e40af' : '#7c3aed'
                              }}>
                                {event.type === 'competition' ? '🏆 Compétition' : 
                                 event.type === 'stage' ? '📚 Stage' : '📝 Examen'}
                              </span>
                            </div>
                            <p style={{ 
                              margin: '0 0 15px 0', 
                              color: '#666', 
                              fontSize: '0.9rem',
                              lineHeight: '1.5'
                            }}>
                              {event.description}
                            </p>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span style={{ color: '#666', fontSize: '0.9rem' }}>📅</span>
                                <span style={{ fontSize: '0.9rem', fontWeight: '500' }}>
                                  {event.dateDebut.toLocaleDateString('fr-FR')} à {event.dateDebut.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                                </span>
                              </div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span style={{ color: '#666', fontSize: '0.9rem' }}>📍</span>
                                <span style={{ fontSize: '0.9rem' }}>{event.lieu}</span>
                              </div>
                            </div>
                          </div>
                          <div style={{ padding: '15px' }}>
                            <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
                                                              <button 
                                  onClick={() => handleEditEvent(event)}
                                  style={{
                                    background: '#2196F3',
                                    color: 'white',
                                    border: 'none',
                                    padding: '6px 12px',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontSize: '0.8rem'
                                  }}
                                >
                                  <EditIcon /> Modifier
                                </button>
                              <button 
                                onClick={() => handleDeleteEvent(event.id)}
                                style={{
                                  background: '#f44336',
                                  color: 'white',
                                  border: 'none',
                                  padding: '6px 12px',
                                  borderRadius: '6px',
                                  cursor: 'pointer',
                                  fontSize: '0.8rem'
                                }}
                              >
                                <DeleteIcon /> Supprimer
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}
        
        {activeTab === 'settings' && (
          <>
            <PageHeader>
              <PageTitle><SettingsIcon /> Paramètres</PageTitle>
              <PageSubtitle>Gérer vos informations de connexion</PageSubtitle>
            </PageHeader>
            
            <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
              <h3 style={{ marginBottom: '20px', color: '#333' }}>Informations du compte</h3>
              <p><strong>Email :</strong> {adminUser?.email}</p>
              <p><strong>Nom :</strong> {adminUser?.nom}</p>
              <p><strong>Prénom :</strong> {adminUser?.prenom}</p>
              <p><strong>Téléphone :</strong> {adminUser?.telephone}</p>
              <p><strong>Rôle :</strong> {adminUser?.role}</p>
              <p><strong>Date de création :</strong> {adminUser?.dateCreation ? formatDate(adminUser.dateCreation) : 'N/A'}</p>
              
              <div style={{ marginTop: '30px', padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
                <h4 style={{ marginBottom: '15px', color: '#666', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <ToolIcon /> Fonctionnalité en développement
                </h4>
                <p style={{ color: '#666', margin: 0 }}>
                  La modification des paramètres sera bientôt disponible. 
                  Pour l'instant, les informations sont en lecture seule.
                </p>
              </div>
            </div>
          </>
        )}

        {activeTab === 'admins' && adminUser?.role === 'super_admin' && (
          <>
            <PageHeader>
              <PageTitle><AdminUserIcon /> Gestion des Administrateurs</PageTitle>
              <PageSubtitle>Créer et gérer les administrateurs du système</PageSubtitle>
            </PageHeader>
            
            <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowCreateAdminModal(true)}
                style={{
                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  fontWeight: '600',
                  fontSize: '1rem',
                  boxShadow: '0 4px 15px rgba(16, 185, 129, 0.3)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.3)';
                }}
              >
                <AddIcon /> Créer un Administrateur
              </button>
            </div>

            <div style={{ background: 'white', padding: '30px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
              {admins.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                  <div style={{ fontSize: '3rem', marginBottom: '20px' }}>👥</div>
                  <h4 style={{ margin: '0 0 10px 0', color: '#333' }}>Aucun administrateur</h4>
                  <p style={{ margin: 0 }}>Commencez par créer votre premier administrateur</p>
                </div>
              ) : (
                <div style={{ overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #e0e0e0' }}>
                        <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#333' }}>Nom</th>
                        <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#333' }}>Prénom</th>
                        <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#333' }}>Email</th>
                        <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#333' }}>Téléphone</th>
                        <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#333' }}>Rôle</th>
                        <th style={{ padding: '15px', textAlign: 'left', fontWeight: '600', color: '#333' }}>Date de création</th>
                        <th style={{ padding: '15px', textAlign: 'center', fontWeight: '600', color: '#333' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {admins.map((admin) => (
                        <tr key={admin.id} style={{ borderBottom: '1px solid #e0e0e0' }}>
                          <td style={{ padding: '15px', color: '#333' }}>{admin.nom}</td>
                          <td style={{ padding: '15px', color: '#333' }}>{admin.prenom}</td>
                          <td style={{ padding: '15px', color: '#333' }}>{admin.email}</td>
                          <td style={{ padding: '15px', color: '#333' }}>{admin.telephone}</td>
                          <td style={{ padding: '15px', color: '#333' }}>
                            <span style={{
                              padding: '4px 12px',
                              borderRadius: '12px',
                              fontSize: '0.85rem',
                              fontWeight: '600',
                              background: admin.role === 'super_admin' ? '#fef3c7' : '#dbeafe',
                              color: admin.role === 'super_admin' ? '#92400e' : '#1e40af'
                            }}>
                              {admin.role === 'super_admin' ? 'Super Admin' : 'Admin'}
                            </span>
                          </td>
                          <td style={{ padding: '15px', color: '#666' }}>
                            {admin.dateCreation ? formatDate(admin.dateCreation) : 'N/A'}
                          </td>
                          <td style={{ padding: '15px', textAlign: 'center' }}>
                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                              <button
                                onClick={() => {
                                  setSelectedAdminForReset(admin);
                                  setShowResetPasswordModal(true);
                                }}
                                style={{
                                  background: '#3b82f6',
                                  color: 'white',
                                  border: 'none',
                                  padding: '8px 16px',
                                  borderRadius: '8px',
                                  cursor: 'pointer',
                                  fontSize: '0.9rem',
                                  fontWeight: '500'
                                }}
                              >
                                Réinitialiser mot de passe
                              </button>
                              {admin.role !== 'super_admin' && (
                                <button
                                  onClick={() => handleDeleteAdmin(admin.id)}
                                  style={{
                                    background: '#ef4444',
                                    color: 'white',
                                    border: 'none',
                                    padding: '8px 16px',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    fontSize: '0.9rem',
                                    fontWeight: '500'
                                  }}
                                >
                                  Supprimer
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </>
        )}
        
        {loading && (
          <LoadingSpinner>Chargement en cours...</LoadingSpinner>
        )}
      </MainContent>

      {/* Modal d'approbation */}
      <ModalOverlay isOpen={approvalModal.isOpen}>
        <ApprovalModalContent>
          <ModalTitle>
            Approuver {approvalModal.type === 'club' ? 'le Club' : 'l\'Athlète'}
          </ModalTitle>
          <ModalDescription>
            Veuillez saisir le montant d'adhésion pour <strong>{approvalModal.itemName}</strong>
          </ModalDescription>
          
          <ModalForm onSubmit={handleApprovalSubmit}>
            <div>
              <SearchLabel>Montant d'adhésion (FCFA) *</SearchLabel>
              <ModalInput
                type="number"
                min="0"
                step="100"
                value={approvalModal.montantAdhesion}
                onChange={(e) => setApprovalModal({
                  ...approvalModal,
                  montantAdhesion: e.target.value
                })}
                placeholder="Ex: 50000"
                required
              />
            </div>
            
            <ModalActions>
              <ModalButton 
                type="button" 
                variant="secondary" 
                onClick={handleApprovalCancel}
                disabled={loading}
              >
                Annuler
              </ModalButton>
              <ModalButton 
                type="submit" 
                variant="primary"
                disabled={loading || !approvalModal.montantAdhesion}
              >
                {loading ? 'Approbation...' : 'Approuver'}
              </ModalButton>
            </ModalActions>
          </ModalForm>
        </ApprovalModalContent>
      </ModalOverlay>

      {/* Modal d'édition de club */}
      <ModalOverlay isOpen={showEditClubModal}>
        <ApprovalModalContent style={{ maxWidth: '700px' }}>
          <ModalTitle>Modifier le club</ModalTitle>
          <ModalDescription>
            Modifiez les informations du club <strong>{editingClub?.nomClub}</strong>
          </ModalDescription>

          <ModalForm onSubmit={handleUpdateClub}>
            <div
              className="edit-club-grid"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                gap: '16px 20px',
                alignItems: 'start'
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <SearchLabel>Nom du club *</SearchLabel>
                <ModalInput
                  type="text"
                  value={clubEditForm.nomClub}
                  onChange={(e) => setClubEditForm({ ...clubEditForm, nomClub: e.target.value })}
                  required
                  style={{ border: '2px solid #000000' }}
                />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <SearchLabel>Grade *</SearchLabel>
                <ModalInput
                  type="text"
                  value={clubEditForm.grade}
                  onChange={(e) => setClubEditForm({ ...clubEditForm, grade: e.target.value })}
                  required
                  style={{ border: '2px solid #000000' }}
                />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <SearchLabel>Nom du maître *</SearchLabel>
                <ModalInput
                  type="text"
                  value={clubEditForm.nomMaitre}
                  onChange={(e) => setClubEditForm({ ...clubEditForm, nomMaitre: e.target.value })}
                  required
                  style={{ border: '2px solid #000000' }}
                />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <SearchLabel>Prénom du maître *</SearchLabel>
                <ModalInput
                  type="text"
                  value={clubEditForm.prenomMaitre}
                  onChange={(e) => setClubEditForm({ ...clubEditForm, prenomMaitre: e.target.value })}
                  required
                  style={{ border: '2px solid #000000' }}
                />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <SearchLabel>Téléphone *</SearchLabel>
                <ModalInput
                  type="tel"
                  value={clubEditForm.telephone}
                  onChange={(e) => setClubEditForm({ ...clubEditForm, telephone: e.target.value })}
                  required
                  style={{ border: '2px solid #000000' }}
                />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <SearchLabel>Ville *</SearchLabel>
                <ModalInput
                  type="text"
                  value={clubEditForm.ville}
                  onChange={(e) => setClubEditForm({ ...clubEditForm, ville: e.target.value })}
                  required
                  style={{ border: '2px solid #000000' }}
                />
              </div>

              <div style={{ gridColumn: '1 / -1', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <SearchLabel>Quartier *</SearchLabel>
                <ModalInput
                  type="text"
                  value={clubEditForm.quartier}
                  onChange={(e) => setClubEditForm({ ...clubEditForm, quartier: e.target.value })}
                  required
                  style={{ border: '2px solid #000000' }}
                />
              </div>
            </div>

            <style>{`
              @media (max-width: 768px) {
                .edit-club-grid {
                  grid-template-columns: 1fr !important;
                }
              }
            `}</style>

            <ModalActions>
              <ModalButton
                type="button"
                variant="secondary"
                onClick={() => {
                  setShowEditClubModal(false);
                  setEditingClub(null);
                }}
                disabled={loading}
              >
                Annuler
              </ModalButton>
              <ModalButton type="submit" variant="primary" disabled={loading}>
                {loading ? 'Enregistrement...' : 'Enregistrer'}
              </ModalButton>
            </ModalActions>
          </ModalForm>
        </ApprovalModalContent>
      </ModalOverlay>

      {/* Modal pour ajouter/modifier les médias */}
      <ModalOverlay isOpen={showMediaModal}>
        <ApprovalModalContent style={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          maxWidth: '600px',
          maxHeight: '90vh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <ModalTitle style={{ color: 'white', fontSize: '1.8rem', marginBottom: '15px' }}>
            {editingMedia ? 'Modifier' : 'Ajouter'} {gestionView === 'videos' ? 'une Vidéo' : 'une Photo'}
          </ModalTitle>
          <ModalDescription style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '20px' }}>
            Remplissez les informations pour {editingMedia ? 'modifier' : 'ajouter'} ce média
          </ModalDescription>
          
          {isUploading && (
            <div style={{
              background: 'rgba(255,255,255,0.1)',
              padding: '15px',
              borderRadius: '10px',
              marginBottom: '20px',
              backdropFilter: 'blur(10px)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                <div style={{
                  width: '20px',
                  height: '20px',
                  border: '2px solid rgba(255,255,255,0.3)',
                  borderTop: '2px solid white',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }} />
                <span style={{ fontWeight: '600' }}>Upload en cours...</span>
              </div>
              <div style={{
                width: '100%',
                height: '6px',
                background: 'rgba(255,255,255,0.2)',
                borderRadius: '3px',
                overflow: 'hidden'
              }}>
                <div style={{
                  width: `${uploadProgress}%`,
                  height: '100%',
                  background: 'linear-gradient(90deg, #4CAF50, #45a049)',
                  transition: 'width 0.3s ease'
                }} />
              </div>
              <div style={{ textAlign: 'center', marginTop: '5px', fontSize: '0.9rem' }}>
                {uploadProgress}%
              </div>
            </div>
          )}
          
          {/* Zone de contenu scrollable */}
          <div style={{ 
            flex: 1, 
            overflowY: 'auto', 
            paddingRight: '10px',
            marginBottom: '20px'
          }}>
            <ModalForm onSubmit={handleMediaSubmit}>
              <div>
                <SearchLabel style={{ color: 'white' }}>Titre *</SearchLabel>
              <ModalInput
                type="text"
                value={mediaForm.title}
                onChange={(e) => setMediaForm({...mediaForm, title: e.target.value})}
                placeholder="Titre du média"
                required
                style={{
                  background: 'rgba(255,255,255,0.1)',
                  border: '2px solid rgba(255,255,255,0.3)',
                  color: 'white',
                  backdropFilter: 'blur(10px)'
                }}
              />
            </div>
            
            <div>
              <SearchLabel style={{ color: 'white' }}>Description</SearchLabel>
              <textarea
                value={mediaForm.description}
                onChange={(e) => setMediaForm({...mediaForm, description: e.target.value})}
                placeholder="Description du média"
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'rgba(255,255,255,0.1)',
                  border: '2px solid rgba(255,255,255,0.3)',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  minHeight: '80px',
                  resize: 'vertical',
                  color: 'white',
                  backdropFilter: 'blur(10px)'
                }}
              />
            </div>
            
            {/* Section Upload de fichier */}
            <div>
              <SearchLabel style={{ color: 'white' }}>
                {gestionView === 'videos' ? 'Fichier vidéo' : 'Fichier image'} *
              </SearchLabel>
              <div style={{
                border: '2px dashed rgba(255,255,255,0.3)',
                borderRadius: '10px',
                padding: '20px',
                textAlign: 'center',
                background: 'rgba(255,255,255,0.05)',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.6)';
                e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'rgba(255,255,255,0.3)';
                e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
              }}
              onClick={() => document.getElementById('file-upload')?.click()}>
                <input
                  id="file-upload"
                  type="file"
                  accept={gestionView === 'videos' ? 'video/*' : 'image/*'}
                  onChange={(e) => handleFileUpload(e, 'media')}
                  style={{ display: 'none' }}
                />
                {uploadedFile ? (
                  <div>
                    <div style={{ fontSize: '2rem', marginBottom: '10px' }}>✅</div>
                    <div style={{ fontWeight: '600', marginBottom: '5px' }}>
                      {uploadedFile.name}
                    </div>
                    <div style={{ fontSize: '0.9rem', opacity: '0.8' }}>
                      {(uploadedFile.size / 1024 / 1024).toFixed(2)} MB
                    </div>
                  </div>
                ) : (
                  <div>
                    <div style={{ fontSize: '2rem', marginBottom: '10px' }}>📁</div>
                    <div style={{ fontWeight: '600', marginBottom: '5px' }}>
                      Cliquez pour sélectionner un fichier
                    </div>
                    <div style={{ fontSize: '0.9rem', opacity: '0.8' }}>
                      {gestionView === 'videos' ? 'MP4, AVI, MOV (max 1 Go)' : 'JPG, PNG, GIF (max 10MB)'}
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            {gestionView === 'videos' && (
              <>
                {/* Section Upload de miniature */}
                <div>
                  <SearchLabel style={{ color: 'white' }}>Miniature (optionnel)</SearchLabel>
                  <div style={{
                    border: '2px dashed rgba(255,255,255,0.3)',
                    borderRadius: '10px',
                    padding: '20px',
                    textAlign: 'center',
                    background: 'rgba(255,255,255,0.05)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(255,255,255,0.6)';
                    e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(255,255,255,0.3)';
                    e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
                  }}
                  onClick={() => document.getElementById('thumbnail-upload')?.click()}>
                    <input
                      id="thumbnail-upload"
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileUpload(e, 'thumbnail')}
                      style={{ display: 'none' }}
                    />
                    {uploadedThumbnail ? (
                      <div>
                        <div style={{ fontSize: '2rem', marginBottom: '10px' }}>✅</div>
                        <div style={{ fontWeight: '600', marginBottom: '5px' }}>
                          {uploadedThumbnail.name}
                        </div>
                        <div style={{ fontSize: '0.9rem', opacity: '0.8' }}>
                          {(uploadedThumbnail.size / 1024 / 1024).toFixed(2)} MB
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div style={{ fontSize: '2rem', marginBottom: '10px' }}>🖼️</div>
                        <div style={{ fontWeight: '600', marginBottom: '5px' }}>
                          Cliquez pour sélectionner une miniature
                        </div>
                        <div style={{ fontSize: '0.9rem', opacity: '0.8' }}>
                          JPG, PNG (max 5MB)
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                
                <div>
                  <SearchLabel style={{ color: 'white' }}>Durée (format: MM:SS)</SearchLabel>
                  <ModalInput
                    type="text"
                    value={mediaForm.duration}
                    onChange={(e) => setMediaForm({...mediaForm, duration: e.target.value})}
                    placeholder="15:30"
                    style={{
                      background: 'rgba(255,255,255,0.1)',
                      border: '2px solid rgba(255,255,255,0.3)',
                      color: 'white',
                      backdropFilter: 'blur(10px)'
                    }}
                  />
                </div>
              </>
            )}
            
            <div>
              <SearchLabel style={{ color: 'white' }}>Catégorie</SearchLabel>
              <select
                value={mediaForm.category}
                onChange={(e) => setMediaForm({...mediaForm, category: e.target.value})}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'rgba(255,255,255,0.1)',
                  border: '2px solid rgba(255,255,255,0.3)',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  color: 'white',
                  backdropFilter: 'blur(10px)'
                }}
              >
                <option value="Compétitions">Compétitions</option>
                <option value="Formation">Formation</option>
                <option value="Cérémonies">Cérémonies</option>
                <option value="Entraînements">Entraînements</option>
                <option value="Événements">Événements</option>
              </select>
            </div>
            
            <ModalActions>
              <ModalButton 
                type="button" 
                variant="secondary" 
                onClick={() => {
                  setShowMediaModal(false);
                  setEditingMedia(null);
                  setMediaForm({
                    title: '',
                    description: '',
                    url: '',
                    thumbnail: '',
                    duration: '',
                    category: 'Compétitions'
                  });
                  setUploadedFile(null);
                  setUploadedThumbnail(null);
                }}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  border: '1px solid rgba(255,255,255,0.3)'
                }}
              >
                Annuler
              </ModalButton>
              <ModalButton 
                type="submit" 
                variant="primary"
                disabled={!mediaForm.title || (!mediaForm.url && !uploadedFile) || isUploading}
                style={{
                  background: isUploading ? 'rgba(255,255,255,0.3)' : 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                  color: 'white'
                }}
              >
                {isUploading ? 'Upload en cours...' : (editingMedia ? 'Modifier' : 'Ajouter')}
              </ModalButton>
            </ModalActions>
          </ModalForm>
          </div>
        </ApprovalModalContent>
      </ModalOverlay>

      {/* Modal simplifié pour l'ajout de vidéo */}
      <ModalOverlay isOpen={showSimpleVideoModal}>
        <ApprovalModalContent style={{ 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          maxWidth: '600px',
          maxHeight: '90vh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <ModalTitle style={{ color: 'white', fontSize: '1.8rem', marginBottom: '15px' }}>
            🎬 Ajouter une vidéo
          </ModalTitle>
          <ModalDescription style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '20px' }}>
            Donnez une description et choisissez une catégorie pour votre vidéo
          </ModalDescription>
          
          {/* Zone de contenu scrollable */}
          <div style={{ 
            flex: 1, 
            overflowY: 'auto', 
            paddingRight: '10px',
            marginBottom: '20px'
          }}>
            {isSimpleVideoUploading && (
              <div style={{
                background: 'rgba(255,255,255,0.15)',
                padding: '20px',
                borderRadius: '15px',
                marginBottom: '20px',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.2)'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
                  <div style={{
                    width: '24px',
                    height: '24px',
                    border: '3px solid rgba(255,255,255,0.3)',
                    borderTop: '3px solid white',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }} />
                  <span style={{ fontWeight: '600', fontSize: '1.1rem' }}>Upload en cours...</span>
                </div>
                <div style={{
                  width: '100%',
                  height: '8px',
                  background: 'rgba(255,255,255,0.2)',
                  borderRadius: '4px',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    width: `${uploadProgress}%`,
                    height: '100%',
                    background: 'linear-gradient(90deg, #4CAF50, #45a049)',
                    transition: 'width 0.3s ease',
                    borderRadius: '4px'
                  }} />
                </div>
                <div style={{ textAlign: 'center', marginTop: '10px', fontSize: '1rem', fontWeight: '500' }}>
                  {uploadProgress}%
                </div>
              </div>
            )}
            
            {simpleVideoFile && (
              <div style={{
                background: 'rgba(255,255,255,0.15)',
                padding: '20px',
                borderRadius: '15px',
                marginBottom: '20px',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.2)'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <div style={{ fontSize: '2.5rem' }}>🎬</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: '600', marginBottom: '8px', fontSize: '1.1rem' }}>
                      {simpleVideoFile.name}
                    </div>
                    <div style={{ fontSize: '1rem', opacity: '0.9' }}>
                      {(simpleVideoFile.size / 1024 / 1024).toFixed(2)} MB
                    </div>
                  </div>
                  <div style={{
                    background: 'rgba(255,255,255,0.2)',
                    padding: '8px 12px',
                    borderRadius: '20px',
                    fontSize: '0.9rem',
                    fontWeight: '500'
                  }}>
                    ✅ Sélectionné
                  </div>
                </div>
              </div>
            )}
            
            <ModalForm onSubmit={handleSimpleVideoSubmit} style={{ gap: '25px' }}>
            <div>
              <SearchLabel style={{ color: 'white' }}>Description de la vidéo *</SearchLabel>
              <textarea
                value={simpleVideoDescription}
                onChange={(e) => setSimpleVideoDescription(e.target.value)}
                placeholder="Décrivez le contenu de votre vidéo..."
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'rgba(255,255,255,0.1)',
                  border: '2px solid rgba(255,255,255,0.3)',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  minHeight: '100px',
                  resize: 'vertical',
                  color: 'white',
                  backdropFilter: 'blur(10px)'
                }}
              />
            </div>
            
            <div>
              <SearchLabel style={{ color: 'white' }}>Catégorie *</SearchLabel>
              <select
                value={simpleVideoCategory}
                onChange={(e) => setSimpleVideoCategory(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'rgba(255,255,255,0.1)',
                  border: '2px solid rgba(255,255,255,0.3)',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  color: 'black',
                  backdropFilter: 'blur(10px)'
                }}
              >
                <option value="">-- Sélectionner une catégorie --</option>
                <option value="Compétitions">🏆 Compétitions</option>
                <option value="Formation">📚 Formation</option>
                <option value="Cérémonies">🎭 Cérémonies</option>
                <option value="Entraînements">🥋 Entraînements</option>
                <option value="Événements">🎉 Événements</option>
                <option value="Techniques">⚡ Techniques</option>
                <option value="Kata">🎯 Kata</option>
                <option value="Kumite">🥊 Kumite</option>
                <option value="Autres">📌 Autres</option>
              </select>
            </div>
            
            <div style={{ 
              background: 'rgba(255,255,255,0.1)', 
              padding: '15px', 
              borderRadius: '10px', 
              marginBottom: '20px',
              backdropFilter: 'blur(10px)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                <div style={{ fontSize: '1.2rem' }}>📅</div>
                <span style={{ fontWeight: '600' }}>Date automatique</span>
              </div>
              <div style={{ fontSize: '0.9rem', opacity: '0.8' }}>
                La vidéo sera datée du {new Date().toLocaleDateString('fr-FR')} à {new Date().toLocaleTimeString('fr-FR', { 
                  hour: '2-digit', 
                  minute: '2-digit' 
                })}
              </div>
            </div>
            
            {/* Boutons d'action à l'intérieur du formulaire */}
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end', marginTop: '20px' }}>
              <button 
                type="button" 
                onClick={() => {
                  setShowSimpleVideoModal(false);
                  setSimpleVideoFile(null);
                  setSimpleVideoDescription('');
                  setSimpleVideoCategory('Compétitions');
                }}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  border: '1px solid rgba(255,255,255,0.3)',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '1rem',
                  fontWeight: '600',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                }}
              >
                Annuler
              </button>
              <button 
                type="submit" 
                disabled={!simpleVideoDescription.trim() || isSimpleVideoUploading}
                onClick={() => {
                  console.log('🔘 Bouton "Ajouter la vidéo" cliqué');
                  console.log('📝 Description:', simpleVideoDescription);
                  console.log('📁 Fichier:', simpleVideoFile);
                  console.log('📂 Catégorie:', simpleVideoCategory);
                }}
                style={{
                  background: isSimpleVideoUploading ? 'rgba(255,255,255,0.3)' : 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '8px',
                  cursor: isSimpleVideoUploading ? 'not-allowed' : 'pointer',
                  fontSize: '1rem',
                  fontWeight: '600',
                  transition: 'all 0.3s ease',
                  opacity: isSimpleVideoUploading ? 0.7 : 1
                }}
                onMouseEnter={(e) => {
                  if (!isSimpleVideoUploading) {
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 6px 20px rgba(76, 175, 80, 0.4)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isSimpleVideoUploading) {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }
                }}
              >
                {isSimpleVideoUploading ? 'Ajout en cours...' : 'Ajouter la vidéo'}
              </button>
            </div>
            
            </ModalForm>
          </div>
        </ApprovalModalContent>
      </ModalOverlay>

      {/* Modal simplifié pour l'ajout d'image */}
      <ModalOverlay isOpen={showSimpleImageModal}>
        <ApprovalModalContent style={{ 
          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          color: 'white',
          maxWidth: '500px'
        }}>
          <ModalTitle style={{ color: 'white', fontSize: '1.8rem' }}>
            Ajouter une image
          </ModalTitle>
          <ModalDescription style={{ color: 'rgba(255,255,255,0.9)' }}>
            Donnez une description à votre image
          </ModalDescription>
          
          {isSimpleImageUploading && (
            <div style={{
              background: 'rgba(255,255,255,0.1)',
              padding: '15px',
              borderRadius: '10px',
              marginBottom: '20px',
              backdropFilter: 'blur(10px)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                <div style={{
                  width: '20px',
                  height: '20px',
                  border: '2px solid rgba(255,255,255,0.3)',
                  borderTop: '2px solid white',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }} />
                <span style={{ fontWeight: '600' }}>Upload en cours...</span>
              </div>
              <div style={{
                width: '100%',
                height: '6px',
                background: 'rgba(255,255,255,0.2)',
                borderRadius: '3px',
                overflow: 'hidden'
              }}>
                <div style={{
                  width: `${uploadProgress}%`,
                  height: '100%',
                  background: 'linear-gradient(90deg, #4CAF50, #45a049)',
                  transition: 'width 0.3s ease'
                }} />
              </div>
              <div style={{ textAlign: 'center', marginTop: '5px', fontSize: '0.9rem' }}>
                {uploadProgress}%
              </div>
            </div>
          )}
          
          {simpleImageFile && (
            <div style={{
              background: 'rgba(255,255,255,0.1)',
              padding: '15px',
              borderRadius: '10px',
              marginBottom: '20px',
              backdropFilter: 'blur(10px)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ fontSize: '2rem' }}>📸</div>
                <div>
                  <div style={{ fontWeight: '600', marginBottom: '5px' }}>
                    {simpleImageFile.name}
                  </div>
                  <div style={{ fontSize: '0.9rem', opacity: '0.8' }}>
                    {(simpleImageFile.size / 1024 / 1024).toFixed(2)} MB
                  </div>
                </div>
              </div>
            </div>
          )}
          
          <ModalForm onSubmit={handleSimpleImageSubmit}>
            <div>
              <SearchLabel style={{ color: 'white' }}>Description de l'image *</SearchLabel>
              <textarea
                value={simpleImageDescription}
                onChange={(e) => setSimpleImageDescription(e.target.value)}
                placeholder="Décrivez le contenu de votre image..."
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'rgba(255,255,255,0.1)',
                  border: '2px solid rgba(255,255,255,0.3)',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  minHeight: '100px',
                  resize: 'vertical',
                  color: 'white',
                  backdropFilter: 'blur(10px)'
                }}
              />
            </div>
            
            <div style={{ 
              background: 'rgba(255,255,255,0.1)', 
              padding: '15px', 
              borderRadius: '10px', 
              marginBottom: '20px',
              backdropFilter: 'blur(10px)'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                <div style={{ fontSize: '1.2rem' }}>📅</div>
                <span style={{ fontWeight: '600' }}>Date automatique</span>
              </div>
              <div style={{ fontSize: '0.9rem', opacity: '0.8' }}>
                L'image sera datée du {new Date().toLocaleDateString('fr-FR')} à {new Date().toLocaleTimeString('fr-FR', { 
                  hour: '2-digit', 
                  minute: '2-digit' 
                })}
              </div>
            </div>
            
            <ModalActions>
              <ModalButton 
                type="button" 
                variant="secondary" 
                onClick={() => {
                  setShowSimpleImageModal(false);
                  setSimpleImageFile(null);
                  setSimpleImageDescription('');
                }}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  border: '1px solid rgba(255,255,255,0.3)'
                }}
              >
                Annuler
              </ModalButton>
              <ModalButton 
                type="submit" 
                variant="primary"
                disabled={!simpleImageDescription.trim() || isSimpleImageUploading}
                style={{
                  background: isSimpleImageUploading ? 'rgba(255,255,255,0.3)' : 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                  color: 'white'
                }}
              >
                {isSimpleImageUploading ? 'Ajout en cours...' : 'Ajouter l\'image'}
              </ModalButton>
            </ModalActions>
          </ModalForm>
        </ApprovalModalContent>
      </ModalOverlay>

      {/* Modal pour la gestion des événements */}
      <ModalOverlay isOpen={showEventModal}>
        <ApprovalModalContent style={{ 
          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
          color: 'white',
          maxWidth: '700px'
        }}>
          <ModalTitle style={{ color: 'white', fontSize: '1.8rem' }}>
            {editingEvent ? 'Modifier' : 'Ajouter'} un événement
          </ModalTitle>
          <ModalDescription style={{ color: 'rgba(255,255,255,0.9)' }}>
            Remplissez les informations pour {editingEvent ? 'modifier' : 'ajouter'} cet événement
          </ModalDescription>
          
          <ModalForm onSubmit={async (e) => {
            e.preventDefault();
            
            try {
              setLoading(true);
              
              if (editingEvent) {
                // Mettre à jour l'événement existant
                await eventService.updateEvent(editingEvent.id, eventForm);
                setMessage({ 
                  type: 'success', 
                  text: 'Événement modifié avec succès !' 
                });
              } else {
                // Créer un nouvel événement
                await eventService.createEvent(eventForm);
                setMessage({ 
                  type: 'success', 
                  text: 'Événement ajouté avec succès !' 
                });
              }
              
              setShowEventModal(false);
              setEditingEvent(null);
              setEventForm({
                titre: '',
                description: '',
                dateDebut: '',
                heureDebut: '',
                dateFin: '',
                heureFin: '',
                lieu: '',
                type: 'competition'
              });
              
              // Recharger les données
              await loadData();
            } catch (error: any) {
              setMessage({ 
                type: 'error', 
                text: error.message || 'Erreur lors de la sauvegarde de l\'événement' 
              });
            } finally {
              setLoading(false);
            }
          }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div>
                <SearchLabel style={{ color: 'white' }}>Titre de l'événement *</SearchLabel>
                <ModalInput
                  type="text"
                  value={eventForm.titre}
                  onChange={(e) => setEventForm({...eventForm, titre: e.target.value})}
                  placeholder="Ex: Championnat National 2024"
                  required
                  style={{
                    background: 'rgba(255,255,255,0.1)',
                    border: '2px solid rgba(255,255,255,0.3)',
                    color: 'white',
                    backdropFilter: 'blur(10px)'
                  }}
                />
              </div>
              
              <div>
                <SearchLabel style={{ color: 'white' }}>Type d'événement *</SearchLabel>
                <select
                  value={eventForm.type}
                  onChange={(e) => setEventForm({...eventForm, type: e.target.value})}
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    background: 'rgba(255,255,255,0.1)',
                    border: '2px solid rgba(255,255,255,0.3)',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    color: 'white',
                    backdropFilter: 'blur(10px)'
                  }}
                >
                  <option value="competition">🏆 Compétition</option>
                  <option value="stage">📚 Stage</option>
                  <option value="examen">📝 Examen</option>
                  <option value="entrainement">🥋 Entraînement</option>
                  <option value="ceremonie">🎭 Cérémonie</option>
                  <option value="autre">📌 Autre</option>
                </select>
              </div>
            </div>
            
            <div>
              <SearchLabel style={{ color: 'white' }}>Description *</SearchLabel>
              <textarea
                value={eventForm.description}
                onChange={(e) => setEventForm({...eventForm, description: e.target.value})}
                placeholder="Décrivez l'événement..."
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'rgba(255,255,255,0.1)',
                  border: '2px solid rgba(255,255,255,0.3)',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  minHeight: '80px',
                  resize: 'vertical',
                  color: 'white',
                  backdropFilter: 'blur(10px)'
                }}
              />
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div>
                <SearchLabel style={{ color: 'white' }}>Date de début *</SearchLabel>
                <ModalInput
                  type="date"
                  value={eventForm.dateDebut}
                  onChange={(e) => setEventForm({...eventForm, dateDebut: e.target.value})}
                  required
                  style={{
                    background: 'rgba(255,255,255,0.1)',
                    border: '2px solid rgba(255,255,255,0.3)',
                    color: 'white',
                    backdropFilter: 'blur(10px)'
                  }}
                />
              </div>
              
              <div>
                <SearchLabel style={{ color: 'white' }}>Heure de début *</SearchLabel>
                <ModalInput
                  type="time"
                  value={eventForm.heureDebut}
                  onChange={(e) => setEventForm({...eventForm, heureDebut: e.target.value})}
                  required
                  style={{
                    background: 'rgba(255,255,255,0.1)',
                    border: '2px solid rgba(255,255,255,0.3)',
                    color: 'white',
                    backdropFilter: 'blur(10px)'
                  }}
                />
              </div>
            </div>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
              <div>
                <SearchLabel style={{ color: 'white' }}>Date de fin *</SearchLabel>
                <ModalInput
                  type="date"
                  value={eventForm.dateFin}
                  onChange={(e) => setEventForm({...eventForm, dateFin: e.target.value})}
                  required
                  style={{
                    background: 'rgba(255,255,255,0.1)',
                    border: '2px solid rgba(255,255,255,0.3)',
                    color: 'white',
                    backdropFilter: 'blur(10px)'
                  }}
                />
              </div>
              
              <div>
                <SearchLabel style={{ color: 'white' }}>Heure de fin *</SearchLabel>
                <ModalInput
                  type="time"
                  value={eventForm.heureFin}
                  onChange={(e) => setEventForm({...eventForm, heureFin: e.target.value})}
                  required
                  style={{
                    background: 'rgba(255,255,255,0.1)',
                    border: '2px solid rgba(255,255,255,0.3)',
                    color: 'white',
                    backdropFilter: 'blur(10px)'
                  }}
                />
              </div>
            </div>
            
            <div>
              <SearchLabel style={{ color: 'white' }}>Lieu *</SearchLabel>
              <ModalInput
                type="text"
                value={eventForm.lieu}
                onChange={(e) => setEventForm({...eventForm, lieu: e.target.value})}
                placeholder="Ex: Dojo Central, Palais des Sports..."
                required
                style={{
                  background: 'rgba(255,255,255,0.1)',
                  border: '2px solid rgba(255,255,255,0.3)',
                  color: 'white',
                  backdropFilter: 'blur(10px)'
                }}
              />
            </div>
            
            <ModalActions>
              <ModalButton 
                type="button" 
                variant="secondary" 
                onClick={() => {
                  setShowEventModal(false);
                  setEditingEvent(null);
                  setEventForm({
                    titre: '',
                    description: '',
                    dateDebut: '',
                    heureDebut: '',
                    dateFin: '',
                    heureFin: '',
                    lieu: '',
                    type: 'competition'
                  });
                }}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  color: 'white',
                  border: '1px solid rgba(255,255,255,0.3)'
                }}
              >
                Annuler
              </ModalButton>
              <ModalButton 
                type="submit" 
                variant="primary"
                disabled={!eventForm.titre || !eventForm.description || !eventForm.dateDebut || !eventForm.heureDebut || !eventForm.dateFin || !eventForm.heureFin || !eventForm.lieu}
                style={{
                  background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                  color: 'white'
                }}
              >
                {editingEvent ? 'Modifier' : 'Ajouter'} l'événement
              </ModalButton>
            </ModalActions>
          </ModalForm>
        </ApprovalModalContent>
      </ModalOverlay>

      {/* Modal de création d'administrateur */}
      <ModalOverlay isOpen={showCreateAdminModal}>
        <ApprovalModalContent style={{ 
          maxWidth: '650px', 
          maxHeight: '90vh', 
          overflowY: 'auto',
          background: 'white',
          color: '#333',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
        }}>
          <ModalTitle style={{ 
            color: '#000', 
            fontSize: '1.8rem', 
            marginBottom: '10px',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            fontWeight: '700'
          }}>
            <AdminUserIcon /> Créer un Administrateur
          </ModalTitle>
          <ModalDescription style={{ 
            color: '#666', 
            marginBottom: '25px',
            fontSize: '1rem'
          }}>
            Remplissez le formulaire pour créer un nouvel administrateur. Les identifiants seront envoyés par email.
          </ModalDescription>
          
          <ModalForm onSubmit={handleCreateAdmin} style={{ gap: '20px' }}>
            {/* Nom et Prénom */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
              <div>
                <SearchLabel style={{ color: '#000', fontWeight: '600', marginBottom: '8px', display: 'block' }}>Nom *</SearchLabel>
                <ModalInput
                  type="text"
                  value={adminForm.nom}
                  onChange={(e) => setAdminForm({...adminForm, nom: e.target.value})}
                  placeholder="Nom"
                  required
                  style={{ 
                    border: '2px solid #000000',
                    background: 'white',
                    color: '#000',
                    width: '100%'
                  }}
                />
              </div>
              
              <div>
                <SearchLabel style={{ color: '#000', fontWeight: '600', marginBottom: '8px', display: 'block' }}>Prénom *</SearchLabel>
                <ModalInput
                  type="text"
                  value={adminForm.prenom}
                  onChange={(e) => setAdminForm({...adminForm, prenom: e.target.value})}
                  placeholder="Prénom"
                  required
                  style={{ 
                    border: '2px solid #000000',
                    background: 'white',
                    color: '#000',
                    width: '100%'
                  }}
                />
              </div>
            </div>

            {/* Civilité et Date de naissance */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
              <div>
                <SearchLabel style={{ color: '#000', fontWeight: '600', marginBottom: '8px', display: 'block' }}>Civilité *</SearchLabel>
                <select
                  value={adminForm.civilite}
                  onChange={(e) => setAdminForm({...adminForm, civilite: e.target.value})}
                  required
                  style={{
                    width: '100%',
                    padding: '14px',
                    border: '2px solid #000000',
                    borderRadius: '12px',
                    fontSize: '1rem',
                    background: 'white',
                    color: '#000',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#10b981'}
                  onBlur={(e) => e.target.style.borderColor = '#000000'}
                >
                  <option value="Monsieur">Monsieur</option>
                  <option value="Madame">Madame</option>
                  <option value="Mademoiselle">Mademoiselle</option>
                </select>
              </div>
              
              <div>
                <SearchLabel style={{ color: '#000', fontWeight: '600', marginBottom: '8px', display: 'block' }}>Date de naissance *</SearchLabel>
                <ModalInput
                  type="date"
                  value={adminForm.dateNaissance}
                  onChange={(e) => setAdminForm({...adminForm, dateNaissance: e.target.value})}
                  required
                  style={{ 
                    border: '2px solid #000000',
                    background: 'white',
                    color: '#000',
                    width: '100%'
                  }}
                />
              </div>
            </div>

            {/* Email */}
            <div>
              <SearchLabel style={{ color: '#000', fontWeight: '600', marginBottom: '8px', display: 'block' }}>Email *</SearchLabel>
              <ModalInput
                type="email"
                value={adminForm.email}
                onChange={(e) => setAdminForm({...adminForm, email: e.target.value})}
                placeholder="email@example.com"
                required
                style={{ 
                  border: '2px solid #000000',
                  background: 'white',
                  color: '#000',
                  width: '100%'
                }}
              />
            </div>

            {/* Téléphone et Ville */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
              <div>
                <SearchLabel style={{ color: '#000', fontWeight: '600', marginBottom: '8px', display: 'block' }}>Téléphone *</SearchLabel>
                <ModalInput
                  type="tel"
                  value={adminForm.telephone}
                  onChange={(e) => setAdminForm({...adminForm, telephone: e.target.value})}
                  placeholder="+225 XX XX XX XX XX"
                  required
                  style={{ 
                    border: '2px solid #000000',
                    background: 'white',
                    color: '#000',
                    width: '100%'
                  }}
                />
              </div>
              
              <div>
                <SearchLabel style={{ color: '#000', fontWeight: '600', marginBottom: '8px', display: 'block' }}>Ville *</SearchLabel>
                <ModalInput
                  type="text"
                  value={adminForm.ville}
                  onChange={(e) => setAdminForm({...adminForm, ville: e.target.value})}
                  placeholder="Ville"
                  required
                  style={{ 
                    border: '2px solid #000000',
                    background: 'white',
                    color: '#000',
                    width: '100%'
                  }}
                />
              </div>
            </div>
            
            <ModalActions style={{ marginTop: '10px' }}>
              <ModalButton 
                type="button" 
                variant="secondary" 
                onClick={() => {
                  setShowCreateAdminModal(false);
                  setAdminForm({
                    nom: '',
                    prenom: '',
                    dateNaissance: '',
                    telephone: '',
                    ville: '',
                    civilite: 'Monsieur',
                    email: '',
                    password: ''
                  });
                }}
                disabled={loading}
                style={{
                  background: '#f3f4f6',
                  color: '#333',
                  border: '2px solid #e5e7eb'
                }}
              >
                Annuler
              </ModalButton>
              <ModalButton 
                type="submit" 
                variant="primary"
                disabled={loading}
                style={{
                  background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                  color: 'white',
                  boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)'
                }}
              >
                {loading ? 'Création...' : 'Créer l\'administrateur'}
              </ModalButton>
            </ModalActions>
          </ModalForm>
        </ApprovalModalContent>
      </ModalOverlay>

      {/* Modal de réinitialisation de mot de passe */}
      <ModalOverlay isOpen={showResetPasswordModal}>
        <ApprovalModalContent style={{ 
          maxWidth: '500px',
          background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
          color: 'white'
        }}>
          <ModalTitle style={{ color: 'white', fontSize: '1.6rem' }}>Réinitialiser le mot de passe</ModalTitle>
          <ModalDescription style={{ color: 'rgba(255,255,255,0.9)' }}>
            Un nouveau mot de passe sera généré et envoyé par email à <strong>{selectedAdminForReset?.email}</strong>
          </ModalDescription>
          
          <ModalActions>
            <ModalButton 
              type="button" 
              variant="secondary" 
              onClick={() => {
                setShowResetPasswordModal(false);
                setSelectedAdminForReset(null);
              }}
              disabled={loading}
              style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                border: '2px solid rgba(255,255,255,0.3)'
              }}
            >
              Annuler
            </ModalButton>
            <ModalButton 
              type="button" 
              variant="primary"
              onClick={() => {
                const password = Math.random().toString(36).slice(-12) + Math.random().toString(36).slice(-12).toUpperCase() + '123!';
                handleResetPassword(password);
              }}
              disabled={loading}
              style={{
                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                color: 'white',
                boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)'
              }}
            >
              {loading ? 'Réinitialisation...' : 'Réinitialiser le mot de passe'}
            </ModalButton>
          </ModalActions>
        </ApprovalModalContent>
      </ModalOverlay>

      {/* Popup pour afficher le nouveau mot de passe */}
      <ModalOverlay isOpen={showPasswordPopup}>
        <ApprovalModalContent style={{ 
          maxWidth: '550px',
          background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
          color: 'white',
          boxShadow: '0 20px 60px rgba(16, 185, 129, 0.4)'
        }}>
          <ModalTitle style={{ 
            color: 'white', 
            fontSize: '1.6rem',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            marginBottom: '15px'
          }}>
            <CheckCircleIcon /> Mot de passe réinitialisé
          </ModalTitle>
          <ModalDescription style={{ color: 'rgba(255,255,255,0.9)', marginBottom: '20px' }}>
            Le nouveau mot de passe pour <strong>{selectedAdminForReset?.email}</strong> a été généré avec succès.
            <br />
            <strong style={{ fontSize: '0.9rem', marginTop: '10px', display: 'block' }}>
              ⚠️ Copiez ce mot de passe maintenant, il ne sera plus visible après la fermeture de cette fenêtre.
            </strong>
          </ModalDescription>
          
          <div style={{
            background: 'rgba(255,255,255,0.15)',
            border: '2px solid rgba(255,255,255,0.3)',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '25px',
            backdropFilter: 'blur(10px)'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between',
              gap: '15px'
            }}>
              <div style={{ flex: 1 }}>
                <div style={{ 
                  fontSize: '0.9rem', 
                  marginBottom: '8px',
                  opacity: 0.9
                }}>
                  Nouveau mot de passe :
                </div>
                <div style={{
                  fontSize: '1.3rem',
                  fontWeight: '700',
                  fontFamily: 'monospace',
                  letterSpacing: '2px',
                  wordBreak: 'break-all',
                  background: 'rgba(0,0,0,0.2)',
                  padding: '12px',
                  borderRadius: '8px',
                  border: '2px solid rgba(255,255,255,0.2)'
                }}>
                  {newPassword}
                </div>
              </div>
              <button
                onClick={copyPasswordToClipboard}
                style={{
                  background: 'rgba(255,255,255,0.2)',
                  border: '2px solid rgba(255,255,255,0.4)',
                  borderRadius: '10px',
                  padding: '12px 16px',
                  cursor: 'pointer',
                  color: 'white',
                  fontSize: '1.2rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.3s ease',
                  minWidth: '50px',
                  height: '50px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                  e.currentTarget.style.transform = 'scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                  e.currentTarget.style.transform = 'scale(1)';
                }}
                title="Copier le mot de passe"
              >
                📋
              </button>
            </div>
          </div>
          
          <ModalActions>
            <ModalButton 
              type="button" 
              variant="primary"
              onClick={() => {
                setShowPasswordPopup(false);
                setSelectedAdminForReset(null);
                setNewPassword('');
                setLoading(false);
                setMessage({ 
                  type: 'success', 
                  text: `Mot de passe réinitialisé avec succès! Un email a été envoyé à ${selectedAdminForReset?.email}` 
                });
                loadAdmins();
              }}
              style={{
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                border: '2px solid rgba(255,255,255,0.4)',
                width: '100%',
                fontSize: '1.1rem',
                padding: '14px'
              }}
            >
              J'ai copié le mot de passe
            </ModalButton>
          </ModalActions>
        </ApprovalModalContent>
      </ModalOverlay>
    </AdminContainer>
  );
}

export default AdminPanel;
